import { createSvgIcon } from './svg-icon';

export const Icon360ViewIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M2 6.7273C2 5.2209 6.4773 4 12 4s10 1.221 10 2.7273m-5.4545 8.4818a33.3 33.3 0 0 0-4.5455-.3 33.3 33.3 0 0 0-4.5454.3"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M2 6.7273C2 5.2209 6.4773 4 12 4s10 1.221 10 2.7273"
      key="1"
    />,
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M2 17.6364c0 1.0591 2.219 1.9754 5.4546 2.4272V9.1546C4.219 8.7 2 7.7909 2 6.7273zm20 0c0 1.0591-2.2191 1.9754-5.4546 2.4272V9.1546C19.7809 8.7 22 7.7909 22 6.7273z"
      key="2"
    />,
  ],
  'Icon360View',
  24
);

export const AddCircleIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 1c6.0751 0 11 4.9249 11 11s-4.9249 11-11 11S1 18.0751 1 12 5.9249 1 12 1m0 6c-.5523 0-1 .4477-1 1v3H8c-.5523 0-1 .4477-1 1s.4477 1 1 1h3v3c0 .5523.4477 1 1 1s1-.4477 1-1v-3h3c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3V8c0-.5523-.4477-1-1-1"
  />,
  'AddCircle',
  24
);

export const AddIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M10.657 6.3431c0-.5522.4476-.9998.9999-.9998s.9999.4476.9999.9998V17.657c0 .5522-.4476.9998-.9999.9998s-.9999-.4476-.9999-.9998z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M5.0001 12c0-.5523.4476-.9999 1-.9999h11.3136c.5523 0 .9999.4476.9999.9999s-.4476.9999-.9999.9999H6c-.5523 0-.9999-.4476-.9999-.9999"
      key="1"
    />,
  ],
  'Add',
  24
);

export const AdministrationIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="currentColor"
        d="M12 0c6.6274 0 12 5.3726 12 12s-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0m-1.5752 7.0127c-.2625.0875-.6126.1747-.875.3496l-1.837-.962L6.4005 7.713l.9619 1.8369c-.175.2624-.2621.6125-.3496.875L5 11.125v1.75l2.0127.7002c.0875.3497.262.6122.3496.9619l-.962 1.8379 1.2247 1.2246 1.8379-.9619c.2624.1748.6121.2622.9619.3496L11.125 19h1.75l.7002-2.0127c.3497-.0875.6122-.2621.9619-.3496l1.8379.9619 1.2246-1.2246-.9619-1.8379c.1748-.2624.2622-.6121.3496-.9619L19 12.875v-1.75l-2.0127-.7002c-.0875-.2625-.1747-.6126-.3496-.875l.9619-1.837-1.2246-1.2255-1.8379.9629c-.2624-.175-.612-.2631-.9619-.3506L12.875 5h-1.75zM12 9.375c1.4875 0 2.625 1.1375 2.625 2.625S13.4875 14.625 12 14.625 9.375 13.4875 9.375 12 10.5125 9.375 12 9.375"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Administration',
  24
);

export const AlertIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M11.9994 1.0001c.5617 0 1.1133.146 1.5947.4229.4815.2768.8753.6739 1.1387 1.1484l8.9111 16.1094a2.84 2.84 0 0 1 .3545 1.4609 2.853 2.853 0 0 1-.4433 1.4385c-.2752.4347-.6637.7941-1.127 1.043a3.19 3.19 0 0 1-1.5176.3769H3.0892a3.19 3.19 0 0 1-1.5175-.3769c-.4634-.2489-.8518-.6083-1.127-1.043a2.85 2.85 0 0 1-.4434-1.4385 2.84 2.84 0 0 1 .3545-1.4609L9.267 2.5714c.2634-.4745.6572-.8716 1.1386-1.1484.4813-.2767 1.0322-.4228 1.5938-.4229m.001 14.5c-.8285 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5c.8282-.0002 1.4999-.6718 1.5-1.5s-.6718-1.4998-1.5-1.5m0-8c-.5523 0-1 .3918-1 .875v4.25c0 .4832.4477.875 1 .875.552-.0002.9999-.3919 1-.875v-4.25c0-.4831-.4479-.8748-1-.875"
  />,
  'Alert',
  24
);

export const AllocateTicketsIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M22.5 2c.828 0 1.5.672 1.5 1.5V9c-1.65 0-3 1.3485-3 3 0 1.65 1.35 3 3 3v5.5c0 .828-.672 1.5-1.5 1.5h-21C.672 22 0 21.328 0 20.5V15c1.65 0 3-1.35 3-3S1.65 9 0 9V3.5C0 2.672.672 2 1.5 2zM10.5498 9.8047H6l3.71 2.5244L8.29 16.5 12 13.917l3.71 2.583-1.42-4.1709L18 9.8047h-4.5498L12 5.5z"
  />,
  'AllocateTickets',
  24
);

export const AnimationsIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M20 7a.75.75 0 0 1-.75-.75 1.5 1.5 0 0 0-1.5-1.5.7499.7499 0 0 1-.5303-1.2803.75.75 0 0 1 .5303-.2197 1.5 1.5 0 0 0 1.5-1.5.7498.7498 0 0 1 1.2803-.5303.75.75 0 0 1 .2197.5303 1.5 1.5 0 0 0 1.5 1.5.7499.7499 0 0 1 .5303 1.2803.75.75 0 0 1-.5303.2197 1.5 1.5 0 0 0-1.5 1.5A.75.75 0 0 1 20 7M4 23a.75.75 0 0 1-.75-.75 1.5 1.5 0 0 0-1.5-1.5.7498.7498 0 0 1-.5303-1.2803.75.75 0 0 1 .5303-.2197 1.5 1.5 0 0 0 1.5-1.5.7499.7499 0 0 1 1.2803-.5303.75.75 0 0 1 .2197.5303 1.5 1.5 0 0 0 1.5 1.5.7498.7498 0 0 1 .5303 1.2803.75.75 0 0 1-.5303.2197 1.5 1.5 0 0 0-1.5 1.5A.75.75 0 0 1 4 23m13 0a1 1 0 0 1-1-1 4 4 0 0 0-1.1716-2.8284A4 4 0 0 0 12 18a1.0001 1.0001 0 0 1 0-2 4 4 0 0 0 2.8284-1.1716A4 4 0 0 0 16 12a1.0001 1.0001 0 0 1 2 0 4 4 0 0 0 1.1716 2.8284A4 4 0 0 0 22 16a1.0001 1.0001 0 0 1 0 2 4 4 0 0 0-2.8284 1.1716A4 4 0 0 0 18 22a1 1 0 0 1-1 1M7 13a1 1 0 0 1-1-1 4 4 0 0 0-4-4 1 1 0 0 1 0-2 4 4 0 0 0 4-4 1 1 0 0 1 2 0 4 4 0 0 0 4 4 1 1 0 1 1 0 2 4 4 0 0 0-4 4 1 1 0 0 1-1 1"
  />,
  'Animations',
  24
);

export const AppIconIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m16.6794 13.7212 5.8266-2.0889c1.2161-.4691 1.7261-1.9131 1.0744-3.0419S21.4232 7.1814 20.4089 8l-4.8405 3.9143c-1.0974-.9822-2.8065-1.3744-4.4672-.4155-1.1659.6731-1.851 1.9985-2.3364 3.2041-.3897.968-.6422 1.965-.8703 2.9807.9942.3093 1.9845.5884 3.0179.7345 1.2856.1817 2.7758.2522 3.9408-.4205 1.738-1.0034 2.2211-2.7928 1.8262-4.2764"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 21h10c.5523 0 1-.4477 1-1v-2h2v2c0 1.6569-1.3431 3-3 3H7c-1.6569 0-3-1.3431-3-3V4c0-1.6568 1.3431-3 3-3h10c1.6568 0 3 1.3432 3 3v1.5h-2V4c0-.5523-.4477-1-1-1H7c-.5523 0-1 .4477-1 1v16c0 .5523.4477 1 1 1"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.5603 4h2.8794c.5856 0 1.0603.4747 1.0603 1.0603s-.4747 1.0603-1.0603 1.0603h-2.8794C9.9747 6.1206 9.5 5.646 9.5 5.0603S9.9747 4 10.5603 4"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'AppIcon',
  24
);

export const AppleIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M18.6594 12.352c.0324 3.5185 3.0571 4.6893 3.0906 4.7043-.0256.0825-.4833 1.6685-1.5935 3.3067-.9599 1.4164-1.9559 2.8275-3.5251 2.8567-1.5419.0287-2.0377-.9231-3.8005-.9231-1.7622 0-2.3131.8939-3.7727.9518-1.5146.058-2.668-1.5315-3.6358-2.9427C3.445 17.4192 1.9338 12.149 3.963 8.5915c1.008-1.7666 2.8095-2.8853 4.7649-2.914 1.4873-.0286 2.8911 1.0103 3.8004 1.0103.9087 0 2.6147-1.2494 4.4081-1.0659.7509.0316 2.8585.3062 4.2117 2.3063-.1091.0682-2.5147 1.4822-2.4886 4.4238m-2.8978-8.6398c.8042-.9828 1.3454-2.351 1.1978-3.7122-1.1592.047-2.5607.7799-3.3921 1.7621-.7451.8698-1.3977 2.262-1.2216 3.5964 1.2919.101 2.6118-.6629 3.4159-1.6463"
  />,
  'Apple',
  24
);

export const AppsIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M4.5 7C5.8807 7 7 5.8807 7 4.5S5.8807 2 4.5 2 2 3.1193 2 4.5 3.1193 7 4.5 7M12 7c1.3807 0 2.5-1.1193 2.5-2.5S13.3807 2 12 2 9.5 3.1193 9.5 4.5 10.6193 7 12 7m7.5 0C20.8807 7 22 5.8807 22 4.5S20.8807 2 19.5 2 17 3.1193 17 4.5 18.1193 7 19.5 7m-15 7.5C5.8807 14.5 7 13.3807 7 12S5.8807 9.5 4.5 9.5 2 10.6193 2 12s1.1193 2.5 2.5 2.5m7.5 0c1.3807 0 2.5-1.1193 2.5-2.5S13.3807 9.5 12 9.5 9.5 10.6193 9.5 12s1.1193 2.5 2.5 2.5m7.5 0c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5S17 10.6193 17 12s1.1193 2.5 2.5 2.5M4.5 22C5.8807 22 7 20.8807 7 19.5S5.8807 17 4.5 17 2 18.1193 2 19.5 3.1193 22 4.5 22m7.5 0c1.3807 0 2.5-1.1193 2.5-2.5S13.3807 17 12 17s-2.5 1.1193-2.5 2.5S10.6193 22 12 22m7.5 0c1.3807 0 2.5-1.1193 2.5-2.5S20.8807 17 19.5 17 17 18.1193 17 19.5s1.1193 2.5 2.5 2.5"
  />,
  'Apps',
  24
);

export const ArchiveContentIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 15h5v2h8v-2h5v3c0 1.6569-1.3431 3-3 3H6c-1.6569 0-3-1.3431-3-3z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 22c-1.6568 0-3-1.3431-3-3V5c0-1.6568 1.3431-3 3-3h14c1.6569 0 3 1.3431 3 3v14c0 1.6569-1.3431 3-3 3zm-1-3c0 .5523.4477 1 1 1h14c.5523 0 1-.4477 1-1V5c0-.5523-.4477-1-1-1H5c-.5523 0-1 .4477-1 1z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 6h6v2H6zm0 4h12v2H6z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'ArchiveContent',
  24
);

export const ArchiveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 15h5v2h8v-2h5v3c0 1.6569-1.3431 3-3 3H6c-1.6569 0-3-1.3431-3-3z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 22c-1.6568 0-3-1.3431-3-3V5c0-1.6568 1.3431-3 3-3h14c1.6569 0 3 1.3431 3 3v14c0 1.6569-1.3431 3-3 3zm-1-3c0 .5523.4477 1 1 1h14c.5523 0 1-.4477 1-1V5c0-.5523-.4477-1-1-1H5c-.5523 0-1 .4477-1 1z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Archive',
  24
);

export const ArrowDownIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M11 18c0 .5523.4478 1 1 1s1-.4477 1-1V6c0-.5523-.4477-1-1-1s-1 .4477-1 1z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M5.293 11.293c-.3905.3905-.3905 1.0235 0 1.414l6 6c.3905.3906 1.0236.3906 1.4141 0l6-6c.3905-.3905.3905-1.0235 0-1.414-.3905-.3906-1.0236-.3906-1.4141 0L12 16.5859 6.707 11.293c-.3904-.3906-1.0235-.3906-1.414 0"
      key="1"
    />,
  ],
  'ArrowDown',
  24
);

export const ArrowLeftIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M7 11c-.5522 0-1 .4477-1 1s.4478 1 1 1h12c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M11.7071 5.293c-.3905-.3906-1.0236-.3906-1.4141 0l-6 6c-.3905.3905-.3905 1.0235 0 1.414l6 6c.3905.3906 1.0236.3906 1.4141 0s.3905-1.0235 0-1.414L6.4141 12l5.293-5.293c.3905-.3905.3905-1.0235 0-1.414"
      key="1"
    />,
  ],
  'ArrowLeft',
  24
);

export const ArrowRightIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M17 11c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1s.4477-1 1-1z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12.293 5.293a.9996.9996 0 0 1 1.414 0l6 6a.9996.9996 0 0 1 0 1.414l-6 6a.9996.9996 0 0 1-1.414 0 .9996.9996 0 0 1 0-1.414L17.5859 12 12.293 6.707a.9997.9997 0 0 1 0-1.414"
      key="1"
    />,
  ],
  'ArrowRight',
  24
);

export const ArrowUpIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M11 6c0-.5523.4478-1 1-1s1 .4477 1 1v12c0 .5523-.4477 1-1 1s-1-.4477-1-1z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M5.293 12.707c-.3905-.3905-.3905-1.0235 0-1.414l6-6c.3905-.3906 1.0236-.3906 1.4141 0l6 6c.3905.3905.3905 1.0235 0 1.414-.3905.3906-1.0236.3906-1.4141 0L12 7.414l-5.293 5.293c-.3904.3906-1.0235.3906-1.414 0"
      key="1"
    />,
  ],
  'ArrowUp',
  24
);

export const BarcodeIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M20 0h-3v19h3zM6 0H4v19h2zm5 0H8v19h3zm4 0h-2v19h2zM2 0H0v24h2zm22 0h-2v24h2z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Barcode',
  24
);

export const CalendarAddIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M20.9092 3C22.0638 3 22.9998 4.0445 23 5.333v7.3779C21.5341 11.0493 19.3901 10 17 10c-4.4183 0-8 3.5817-8 8 0 2.3901 1.0493 4.5341 2.7109 6h-9.62C.9361 23.9999.0001 22.9555 0 21.667V5.333C.0002 4.0445.9362 3 2.0908 3z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M5 6V2c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1m11 0V2c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1m1 6c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6m-1 5h-2v2h2v2h2v-2h2v-2h-2v-2h-2z"
      key="1"
    />,
  ],
  'CalendarAdd',
  24
);

export const CalendarChangeIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M20.9092 3C22.0638 3 22.9998 4.0445 23 5.333V11h-4v.3145A7.49 7.49 0 0 0 16.8535 11c-2.2215.0001-4.2202.97-5.5889 2.499l-2.001 2.2354.8555.7656H9V24H2.0908C.9362 23.9999.0002 22.9555 0 21.667V5.333C.0002 4.0445.9362 3 2.0908 3z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M5 6V2c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1m11 0V2c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1m.5 14.5h-2.2266c.6324.9067 1.6839 1.5 2.8731 1.5 1.036-.0001 1.9661-.4495 2.6084-1.167l.667-.7451 1.4902 1.334-.667.7451c-1.0056 1.1234-2.4699 1.8329-4.0986 1.833-1.6554 0-3.1387-.7314-4.1465-1.8877V24h-2v-5.5h5.5zm6.5-2h-5.5v-2h2.2266c-.6324-.9067-1.6839-1.5-2.8731-1.5-1.036.0001-1.9661.4495-2.6084 1.167l-.667.7451-1.4902-1.334.667-.7451c1.0056-1.1234 2.4699-1.8329 4.0986-1.833 1.6551 0 3.1387.7307 4.1465 1.8867V13h2z"
      key="1"
    />,
  ],
  'CalendarChange',
  24
);

export const CalendarCheckIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M20.9092 3C22.0638 3 22.9998 4.0445 23 5.333v16.334c-.0002 1.2885-.9362 2.3329-2.0908 2.333H2.0908C.9362 23.9999.0002 22.9555 0 21.667V5.333C.0002 4.0445.9362 3 2.0908 3zm-4.2022 7.293a.9996.9996 0 0 0-1.414 0L9.5 16.0859 7.707 14.293a.9997.9997 0 0 0-1.414 0 .9996.9996 0 0 0 0 1.414L9.5 18.9141l7.207-7.2071a.9996.9996 0 0 0 0-1.414"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M5 6V2c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1m11 0V2c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1"
      key="1"
    />,
  ],
  'CalendarCheck',
  24
);

export const CalendarClockIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M20.9092 3C22.0638 3 22.9998 4.0445 23 5.333v7.3779C21.5341 11.0493 19.3901 10 17 10c-4.4183 0-8 3.5817-8 8 0 2.3901 1.0493 4.5341 2.7109 6h-9.62C.9361 23.9999.0001 22.9555 0 21.667V5.333C.0002 4.0445.9362 3 2.0908 3z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M5 6V2c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1m11 0V2c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1m1 18c3.314 0 6-2.686 6-6s-2.686-6-6-6-6 2.686-6 6 2.686 6 6 6m-1-10h2v3h3v2h-5z"
      key="1"
    />,
  ],
  'CalendarClock',
  24
);

export const CalendarRemoveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M20.9092 3C22.0638 3 22.9998 4.0445 23 5.333v7.3779C21.5341 11.0493 19.3901 10 17 10c-4.4183 0-8 3.5817-8 8 0 2.3901 1.0493 4.5341 2.7109 6h-9.62C.9361 23.9999.0001 22.9555 0 21.667V5.333C.0002 4.0445.9362 3 2.0908 3z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M5 6V2c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1m11 0V2c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1m1 6c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6m-3 5v2h6v-2z"
      key="1"
    />,
  ],
  'CalendarRemove',
  24
);

export const CalendarIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M20.9092 3C22.0638 3 22.9998 4.0445 23 5.333v16.334c-.0002 1.2885-.9362 2.3329-2.0908 2.333H2.0908C.9362 23.9999.0002 22.9555 0 21.667V5.333C.0002 4.0445.9362 3 2.0908 3zM5.5 15a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm5 0a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm5 0a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm-10-5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm5 0a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm5 0a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M5 6V2c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1m11 0V2c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1"
      key="1"
    />,
  ],
  'Calendar',
  24
);

export const CallIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="m21.2 17.676-5.59-2.4a1 1 0 0 0-1.1.211l-2.334 2.3A18.95 18.95 0 0 1 8.8 15.2a19.15 19.15 0 0 1-2.588-3.37l2.3-2.33a1 1 0 0 0 .208-1.1l-2.4-5.59a1 1 0 0 0-1.17-.573L.75 3.4a1 1 0 0 0-.75 1 21.143 21.143 0 0 0 5.985 13.616A21.135 21.135 0 0 0 19.606 24a1 1 0 0 0 1-.749l1.162-4.4a1 1 0 0 0-.568-1.175M18 10a1.0001 1.0001 0 0 0 2 0 6.006 6.006 0 0 0-6-6 1 1 0 1 0 0 2 4 4 0 0 1 4 4" />
      <path d="M14 0a1 1 0 1 0 0 2 8.009 8.009 0 0 1 8 8 1.0001 1.0001 0 0 0 2 0A10.011 10.011 0 0 0 14 0" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Call',
  24
);

export const CameraIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M21 4h-4l-2-3H9L7 4H3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m-9 14a5 5 0 1 1 0-10.0002A5 5 0 0 1 12 18"
  />,
  'Camera',
  24
);

export const Camera360Icon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M21.988 13.119a3.96 3.96 0 0 1-.611 2c.412.327.623.636.623.877 0 .569-1.088 1.494-3.478 2.18a1 1 0 0 0 .275 1.961 1 1 0 0 0 .276-.039C22.25 19.191 24 17.734 24 16a3.527 3.527 0 0 0-2.012-2.881M18 3h-2.382L14.9 1.553A1 1 0 0 0 14 1h-4a1 1 0 0 0-.895.553L8.382 3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-6 9a2.9995 2.9995 0 0 1-2.7716-1.8519 3.0003 3.0003 0 0 1 2.1863-4.0905 3 3 0 0 1 3.0797 1.2757 2.9996 2.9996 0 0 1-.3731 3.788A3 3 0 0 1 12 12" />
      <path d="m14.707 19.293-3-3a.9997.9997 0 0 0-1.4018.0122 1 1 0 0 0-.0122 1.4018l1.285 1.285C5.806 18.909 2 17.166 2 16c0-.241.211-.55.623-.877a3.96 3.96 0 0 1-.611-2A3.528 3.528 0 0 0 0 16c0 3.208 5.765 4.916 11.593 4.993l-1.3 1.3a1 1 0 0 0-.2308 1.098 1 1 0 0 0 1.6448.316l3-3a1 1 0 0 0 0-1.414" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Camera360',
  24
);

export const CardAddIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M1 4c0-1.6568 1.3432-3 3-3h16c1.6569 0 3 1.3432 3 3v1H1zm22 7.7568C21.6303 10.6585 19.8925 10 18 10c-4.4186 0-8 3.5814-8 8 0 .3388.0236.6723.0645 1H4c-1.6568 0-3-1.3431-3-3V8h22zM4 15h4v-2H4z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M18 12c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6m-1 5h-2v2h2v2h2v-2h2v-2h-2v-2h-2z"
      key="1"
    />,
  ],
  'CardAdd',
  24
);

export const CardEditIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M1 6c0-1.6569 1.3432-3 3-3h16c1.6569 0 3 1.3431 3 3v1H1zm15 17 6.5-6.5c.8284-.8284.8284-2.1716 0-3s-2.1716-.8284-3 0L13 20v3z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 10v8c0 1.6569 1.3432 3 3 3h7v-.5858a3 3 0 0 1 .8787-2.1213l6.2071-6.2071c1.3323-1.3323 3.3499-1.5618 4.9183-.6883 0 0-.0047-.9324-.0041-1.3975zm3 7v-2h4v2z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'CardEdit',
  24
);

export const CardRemoveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M1 4c0-1.6568 1.3432-3 3-3h16c1.6569 0 3 1.3432 3 3v1H1zm22 7.7568C21.6303 10.6585 19.8925 10 18 10c-4.4186 0-8 3.5814-8 8 0 .3388.0236.6723.0645 1H4c-1.6568 0-3-1.3431-3-3V8h22zM4 15h4v-2H4z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M18 12c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6m-3 5v2h6v-2z"
      key="1"
    />,
  ],
  'CardRemove',
  24
);

export const CardIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 10H1v8c0 1.6569 1.3432 3 3 3h16c1.6569 0 3-1.3431 3-3v-5h-5c-1.1046 0-2-.8954-2-2zM5 17v-2h4v2z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.5066 8.5115C17.2257 8.2246 16.7568 8 16.0001 8h-1V6h1c1.1656 0 2.1969.358 2.9355 1.1123.7352.751 1.0648 1.7764 1.0648 2.8877v1h-2v-1c0-.7235-.2095-1.198-.4938-1.4885"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.9997 10c0-3.461-2.4792-6-5.9997-6h-1V2h1c4.6391 0 7.9997 3.4484 7.9997 8v1h-2z"
      clipRule="evenodd"
      key="2"
    />,
    <path fill="currentColor" d="M13 3v4H1V6c0-1.657 1.3432-3 3-3z" key="3" />,
  ],
  'Card',
  24
);

export const CaretDownIcon = createSvgIcon(
  <path fill="currentColor" d="M18 8.5H6l6 9z" />,
  'CaretDown',
  24
);

export const CaretExpandIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 1.8 6.036 10h11.928zM6.036 14 12 22.2l5.964-8.2z"
  />,
  'CaretExpand',
  24
);

export const CaretLeftIcon = createSvgIcon(
  <path fill="currentColor" d="M15.5 18V6l-9 6z" />,
  'CaretLeft',
  24
);

export const CaretRightIcon = createSvgIcon(
  <path fill="currentColor" d="M8.5 6v12l9-6z" />,
  'CaretRight',
  24
);

export const CaretUpIcon = createSvgIcon(
  <path fill="currentColor" d="M18 15.5H6l6-9z" />,
  'CaretUp',
  24
);

export const CartAddIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M6 23c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2M5.4385 5h17.7803l-1.2159 6.0742A7.96 7.96 0 0 0 18 10c-4.0798 0-7.4434 3.0536-7.9355 7H7.7344c-1.483 0-2.7607-1.1072-2.9707-2.5752L3.1328 3H0V1h4.8672z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M18 12c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6m-1 5h-2v2h2v2h2v-2h2v-2h-2v-2h-2z"
      key="1"
    />,
  ],
  'CartAdd',
  24
);

export const CartRemoveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M6 23c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2M5.4385 5h17.7803l-1.2159 6.0742A7.96 7.96 0 0 0 18 10c-4.0798 0-7.4434 3.0536-7.9355 7H7.7344c-1.483 0-2.7607-1.1072-2.9707-2.5752L3.1328 3H0V1h4.8672z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M18 12c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6m-3 5v2h6v-2z"
      key="1"
    />,
  ],
  'CartRemove',
  24
);

export const CartIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M6 23c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2m14 0c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2m-1.64-6H7.734c-1.483 0-2.76-1.107-2.97-2.575L3.133 3H0V1h4.867l.571 4h17.781l-1.918 9.589C21.023 15.985 19.785 17 18.36 17"
  />,
  'Cart',
  24
);

export const CenterIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 14c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2M8.6357 3.95l2.6573-2.657.076-.069c.3927-.3202.9722-.297 1.3382.069l2.6571 2.657.0683.0752c.3206.3928.2979.9728-.0683 1.339s-.9462.3889-1.339.0683l-.0752-.0683L12 3.4143l-1.9501 1.95-.0752.0683c-.3928.3206-.9728.2979-1.339-.0683s-.3889-.9462-.0683-1.339zM3.9501 15.3643l-2.6572-2.6572-.069-.076c-.3202-.3927-.297-.9722.069-1.3382l2.6572-2.6572.0753-.0683c.3927-.3206.9727-.2979 1.339.0683.366.3662.3888.9462.0683 1.339l-.0684.0752L3.4143 12l1.95 1.9501.0684.0752c.3205.3928.2978.9728-.0684 1.339s-.9462.3889-1.339.0683zm16.0998-6.7286 2.6572 2.6572.069.076c.3202.3927.297.9722-.069 1.3382l-2.6572 2.6572-.0753.0683c-.3927.3206-.9727.2979-1.3389-.0683s-.3889-.9462-.0684-1.339l.0684-.0752L20.5858 12l-1.9501-1.9501-.0684-.0752c-.3205-.3928-.2978-.9728.0684-1.339s.9462-.3889 1.3389-.0683zm-4.6856 11.4142-2.6572 2.6572-.076.0691c-.3927.3201-.9722.297-1.3382-.0691l-2.6572-2.6572-.0683-.0752c-.3206-.3928-.2979-.9728.0683-1.339s.9462-.3889 1.339-.0683l.0752.0683L12 20.5858l1.9501-1.9501.0752-.0683c.3928-.3206.9728-.2979 1.339.0683s.3889.9462.0683 1.339z"
  />,
  'Center',
  24
);

export const ChartBarIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M10 4c0-1.1046.8954-2 2-2s2 .8954 2 2v16c0 1.1046-.8954 2-2 2s-2-.8954-2-2zm8 6c0-1.1046.8954-2 2-2s2 .8954 2 2v10c0 1.1046-.8954 2-2 2s-2-.8954-2-2zM2 16c0-1.1046.8954-2 2-2s2 .8954 2 2v4c0 1.1046-.8954 2-2 2s-2-.8954-2-2z"
  />,
  'ChartBar',
  24
);

export const ChartBar2Icon = createSvgIcon(
  <path
    fill="currentColor"
    d="M23 20H1v2h22zM7 7H1v11h6zm8-5H9v16h6zm8 9h-6v7h6z"
  />,
  'ChartBar2',
  24
);

export const ChartDonutIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M13 6.09c2.511.422 4.488 2.399 4.91 4.91h5.039c-.476-5.276-4.674-9.473-9.95-9.95v5.039zm-6.014 9.2C6.365 14.345 6 13.215 6 12c0-2.972 2.163-5.433 5-5.91V1.05C5.394 1.556 1 6.262 1 12c0 2.572.89 4.933 2.369 6.806zM17.9099 13c-.477 2.837-2.938 5-5.91 5-1.375 0-2.639-.468-3.651-1.246l-3.602 3.502C6.684 21.959 9.218 23 12 23c5.738 0 10.444-4.394 10.95-10z"
  />,
  'ChartDonut',
  24
);

export const ChatIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M20 2H4C2.346 2 1 3.346 1 5v10c0 1.654 1.346 3 3 3h1v5.943L13.32 18H20c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3"
  />,
  'Chat',
  24
);

export const CheckIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M18.2969 6.289c.3927-.3883 1.0257-.3848 1.4141.0079s.3849 1.0257-.0078 1.414l-9.0996 9c-.3896.3853-1.0167.3852-1.4063 0L4.297 11.8652c-.3926-.3883-.3961-1.0223-.0078-1.415.3883-.3923 1.0215-.3958 1.414-.0078l4.1964 4.1504z"
  />,
  'Check',
  24
);

export const CheckboxBlankIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M18 19v2H6v-2zm1-1V6c0-.5523-.4477-1-1-1H6c-.5523 0-1 .4477-1 1v12c0 .5523.4477 1 1 1v2c-1.6051 0-2.9158-1.2606-2.996-2.8457L3 18V6c0-1.6569 1.3431-3 3-3h12l.1543.004C19.7394 3.0841 21 4.3948 21 6v12l-.0039.1543c-.0777 1.534-1.3078 2.7641-2.8418 2.8418L18 21v-2c.5523 0 1-.4477 1-1"
  />,
  'CheckboxBlank',
  24
);

export const CheckboxFilledIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M18 3c1.6569 0 3 1.3431 3 3v12c0 1.6569-1.3431 3-3 3H6c-1.6569 0-3-1.3431-3-3V6c0-1.6569 1.3431-3 3-3z"
      key="0"
    />,
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M17.7071 8.2929c.3905.3905.3905 1.0237 0 1.4142l-6.6667 6.6667a1 1 0 0 1-1.4142 0L6.293 13.0404c-.3905-.3905-.3905-1.0236 0-1.4142s1.0237-.3905 1.4142 0l2.6262 2.6263 5.9596-5.9596c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'CheckboxFilled',
  24
);

export const CheckboxIndeterminateIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M18 3c1.6569 0 3 1.3431 3 3v12c0 1.6569-1.3431 3-3 3H6c-1.6569 0-3-1.3431-3-3V6c0-1.6569 1.3431-3 3-3z"
      key="0"
    />,
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8 12h8"
      key="1"
    />,
  ],
  'CheckboxIndeterminate',
  24
);

export const CheckmarkIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1m-1.951 16.463L5.586 13 7 11.586l2.951 2.951 6.955-7.948 1.505 1.317z"
  />,
  'Checkmark',
  24
);

export const ChevronDownIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M18.707 8.293c.3905.3905.3905 1.0235 0 1.414l-6 6c-.3905.3905-1.0236.3905-1.4141 0l-6-6c-.3905-.3905-.3905-1.0235 0-1.414.3905-.3906 1.0236-.3906 1.414 0L12 13.5859l5.2929-5.293c.3905-.3905 1.0236-.3905 1.4141 0"
  />,
  'ChevronDown',
  24
);

export const ChevronLeftIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M14.707 5.293c-.3905-.3906-1.0236-.3906-1.4141 0l-6 6c-.3905.3905-.3905 1.0235 0 1.414l6 6c.3905.3905 1.0236.3905 1.4141 0s.3905-1.0235 0-1.414L9.414 12l5.293-5.293c.3905-.3905.3905-1.0235 0-1.414"
  />,
  'ChevronLeft',
  24
);

export const ChevronRightIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M9.293 5.293c.3905-.3906 1.0236-.3906 1.4141 0l6 6c.3905.3905.3905 1.0235 0 1.414l-6 6c-.3905.3905-1.0236.3905-1.414 0a.9996.9996 0 0 1 0-1.414L14.586 12 9.293 6.707c-.3905-.3905-.3905-1.0235 0-1.414"
  />,
  'ChevronRight',
  24
);

export const ChevronUpIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M18.707 15.707c.3905-.3905.3905-1.0235 0-1.414l-6-6c-.3905-.3905-1.0236-.3905-1.4141 0l-6 6c-.3905.3905-.3905 1.0235 0 1.414.3905.3906 1.0236.3906 1.414 0L12 10.4141l5.2929 5.2929c.3905.3906 1.0236.3906 1.4141 0"
  />,
  'ChevronUp',
  24
);

export const CityIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="m23.287 3.042-10-3A1 1 0 0 0 12 1v5h2V2.344l8 2.4v17.2561h-6v-13a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v13H2v-10H1a.9997.9997 0 0 0-1 1v10a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-19a1 1 0 0 0-.713-.958M11.5 21.0002h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5m0-4h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5m0-4h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5" />
      <path d="M19.5 8h-1a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5" />
    </g>,
    <defs key="1"></defs>,
  ],
  'City',
  24
);

export const ClockIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1m4.2 15.4L11 12.5V5h2v6.5l4.4 3.3z"
  />,
  'Clock',
  24
);

export const CloseIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1m4.914 14.5L15.5 16.914l-3.5-3.5-3.5 3.5L7.086 15.5l3.5-3.5-3.5-3.5L8.5 7.086l3.5 3.5 3.5-3.5L16.914 8.5l-3.5 3.5z"
  />,
  'Close',
  24
);

export const CloudDownloadIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M3.0665 10.3526C3.6263 6.2474 7.2043 3 11.5 3c4.2459 0 7.6859 3.0787 8.3907 7.0798C22.2211 10.5024 24 12.5515 24 15c0 2.7523-2.2477 5-5 5H5c-2.7523 0-5-2.2477-5-5 0-2.0896 1.2685-3.9096 3.0665-4.6474M13.0001 12.5V8h-2v4.5H7l5 6 5-6z"
    clipRule="evenodd"
  />,
  'CloudDownload',
  24
);

export const CloudUploadIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M3.0665 10.3526C3.6263 6.2474 7.2043 3 11.5 3c4.2459 0 7.6859 3.0787 8.3907 7.0798C22.2211 10.5024 24 12.5515 24 15c0 2.7523-2.2477 5-5 5H5c-2.7523 0-5-2.2477-5-5 0-2.0896 1.2685-3.9096 3.0665-4.6474M13.0001 13.5V18h-2v-4.5H7l5-6 5 6z"
    clipRule="evenodd"
  />,
  'CloudUpload',
  24
);

export const ClusterIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M9 1C4.5817 1 1 4.5817 1 9s3.5817 8 8 8 8-3.5817 8-8-3.5817-8-8-8"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m19.947 8.634.707.707C22.167 10.853 23 12.863 23 15c0 4.411-3.589 8-8 8-2.139 0-4.148-.833-5.66-2.347l-.706-.708 1.415-1.413.707.708C11.889 20.375 13.396 21 15 21c3.309 0 6-2.691 6-6 0-1.603-.625-3.11-1.76-4.245l-.707-.707z"
      key="1"
    />,
  ],
  'Cluster',
  24
);

export const CollapseHorizontalIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M21 11H8.5c-.5523 0-1 .4477-1 1s.4477 1 1 1H21c.5523 0 1-.4477 1-1s-.4477-1-1-1"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12.793 17.707a.9996.9996 0 0 0 1.414 0 .9996.9996 0 0 0 0-1.414L9.914 12l4.293-4.293a.9997.9997 0 0 0 0-1.414.9996.9996 0 0 0-1.414 0L7.086 12zM4 21l-.0049.1025C3.9438 21.6067 3.5177 22 3 22s-.9438-.3933-.9951-.8975L2 21V3c0-.5523.4477-1 1-1s1 .4477 1 1z"
      key="1"
    />,
  ],
  'CollapseHorizontal',
  24
);

export const CopyIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M10 22H8.5C7.122 22 6 20.878 6 19.5V16h2v3.5c0 .276.224.5.5.5H10zm6-2h-4v2h4zm3.5 2H18v-2h1.5c.276 0 .5-.224.5-.5V18h2v1.5c0 1.378-1.122 2.5-2.5 2.5M22 12h-2v4h2zm0-2h-2V8.5c0-.276-.224-.5-.5-.5H16V6h3.5C20.878 6 22 7.122 22 8.5z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M15.5 2h-11C3.1193 2 2 3.1193 2 4.5v11C2 16.8807 3.1193 18 4.5 18h11c1.3807 0 2.5-1.1193 2.5-2.5v-11C18 3.1193 16.8807 2 15.5 2"
      key="1"
    />,
  ],
  'Copy',
  24
);

export const CornerLeftUpIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M10 13V5c0-.5523-.4477-1-1-1s-1 .4477-1 1v8c0 3.8663 3.1338 7 7 7h5c.5523 0 1-.4477 1-1s-.4477-1-1-1h-5c-2.7617 0-5-2.2383-5-5"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M9.631 3.2246c-.3929-.3203-.9719-.2977-1.338.0684l-5 5c-.3905.3905-.3905 1.0235 0 1.414.3905.3906 1.0236.3906 1.414 0L9 5.414l4.293 4.293c.3905.3906 1.0236.3906 1.4141 0s.3905-1.0235 0-1.414l-5-5z"
      key="1"
    />,
  ],
  'CornerLeftUp',
  24
);

export const CornerRightUpIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M14 13V5c0-.5523.4477-1 1-1s1 .4477 1 1v8c0 3.8663-3.1337 7-7 7H4c-.5523 0-1-.4477-1-1s.4477-1 1-1h5c2.7617 0 5-2.2383 5-5"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M14.3691 3.2246c.3928-.3203.9718-.2977 1.3379.0684l5 5a.9997.9997 0 0 1 0 1.414.9996.9996 0 0 1-1.414 0L15 5.414l-4.293 4.293a.9996.9996 0 0 1-1.414 0 .9996.9996 0 0 1 0-1.414l5-5z"
      key="1"
    />,
  ],
  'CornerRightUp',
  24
);

export const CrossIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M17.293 5.293c.3905-.3906 1.0236-.3906 1.4141 0s.3905 1.0235 0 1.414l-12 12c-.3905.3905-1.0236.3905-1.414 0a.9996.9996 0 0 1 0-1.414z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M5.293 5.293c.3905-.3906 1.0236-.3906 1.414 0l12.0001 12c.3905.3905.3905 1.0235 0 1.414s-1.0236.3905-1.4141 0l-12-12c-.3905-.3905-.3905-1.0235 0-1.414"
      key="1"
    />,
  ],
  'Cross',
  24
);

export const CurrencyIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M17 16c-2.951 0-5.403-.639-7-1.712V16c0 1.657 3.134 3 7 3s7-1.343 7-3v-1.712C22.403 15.361 19.951 16 17 16m0 5c-2.951 0-5.403-.639-7-1.712V21c0 1.657 3.134 3 7 3s7-1.343 7-3v-1.712C22.403 20.361 19.951 21 17 21m0-7c3.866 0 7-1.3431 7-3s-3.134-3-7-3-7 1.3431-7 3 3.134 3 7 3M7 6c3.866 0 7-1.3431 7-3s-3.134-3-7-3-7 1.3432-7 3 3.134 3 7 3m1 11.973c-.327.016-.659.027-1 .027-2.951 0-5.403-.639-7-1.712V18c0 1.657 3.134 3 7 3 .34 0 .673-.014 1-.034zm0-5c-.327.016-.659.027-1 .027-2.951 0-5.403-.639-7-1.712V13c0 1.657 3.134 3 7 3 .34 0 .673-.014 1-.034zm1.92-5.207C9.018 7.916 8.042 8 7 8c-2.951 0-5.403-.639-7-1.712V8c0 1.657 3.134 3 7 3 .341 0 .674-.014 1.003-.034.012-1.263.707-2.36 1.917-3.2" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Currency',
  24
);

export const CustomersIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M12 6c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3M6 19c-1.105 0-2-.895-2-2v-6c0-1.13.391-2.162 1.026-3H2c-1.105 0-2 .895-2 2v5c0 .552.448 1 1 1h1v5c0 .552.448 1 1 1h2c.552 0 1-.448 1-1zm8 5h-4c-.552 0-1-.448-1-1v-6H7c-.552 0-1-.448-1-1v-5c0-1.657 1.343-3 3-3h6c1.657 0 3 1.343 3 3v5c0 .552-.448 1-1 1h-2v6c0 .552-.448 1-1 1M4 7c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2m14 12c1.105 0 2-.895 2-2v-6c0-1.13-.391-2.162-1.026-3H22c1.105 0 2 .895 2 2v5c0 .552-.448 1-1 1h-1v5c0 .552-.448 1-1 1h-2c-.552 0-1-.448-1-1zm2-12c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Customers',
  24
);

export const DarkModeIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M20.4 14.7q-1.2.3-2.4.3c-5 0-9-4-9-9q0-1.2.3-2.4c.1-.3 0-.7-.3-1s-.6-.4-1-.3C3.3 3.7 0 8.1 0 13c0 6.1 4.9 11 11 11 4.9 0 9.3-3.3 10.6-8.1.1-.3 0-.7-.3-1-.2-.2-.6-.3-.9-.2M13 4h1v1c0 .6.4 1 1 1s1-.4 1-1V4h1c.6 0 1-.4 1-1s-.4-1-1-1h-1V1c0-.6-.4-1-1-1s-1 .4-1 1v1h-1c-.6 0-1 .4-1 1s.4 1 1 1m10 4h-1V7c0-.6-.4-1-1-1s-1 .4-1 1v1h-1c-.6 0-1 .4-1 1s.4 1 1 1h1v1c0 .6.4 1 1 1s1-.4 1-1v-1h1c.6 0 1-.4 1-1s-.4-1-1-1" />
    </g>,
    <defs key="1"></defs>,
  ],
  'DarkMode',
  24
);

export const DashboardsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="currentColor"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0M5 12c0 .552-.447 1-1 1s-1-.448-1-1c0-1.387.325-2.696.887-3.871l1.526 1.526C5.15 10.389 5 11.177 5 12m7 3c-1.654 0-3-1.346-3-3 0-.462.113-.894.3-1.285L5.086 6.5 6.5 5.086l4.214 4.215C11.106 9.114 11.538 9 12 9c1.654 0 3 1.346 3 3s-1.346 3-3 3m8-2c-.553 0-1-.448-1-1 0-3.86-3.141-7-7-7-.823 0-1.61.15-2.345.413L8.13 3.887C9.304 3.324 10.613 3 12 3c4.963 0 9 4.038 9 9 0 .552-.447 1-1 1"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Dashboards',
  24
);

export const DeclineTicketsIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M22.5 2c.828 0 1.5.672 1.5 1.5V9c-1.65 0-3 1.3485-3 3 0 1.65 1.35 3 3 3v5.5c0 .828-.672 1.5-1.5 1.5h-21C.672 22 0 21.328 0 20.5V15c1.65 0 3-1.35 3-3S1.65 9 0 9V3.5C0 2.672.672 2 1.5 2zm-6.793 6.293a.9996.9996 0 0 0-1.414 0L12 10.5859l-2.293-2.293c-.3905-.3905-1.0235-.3905-1.414 0-.3906.3906-.3906 1.0236 0 1.4141L10.5859 12l-2.293 2.293c-.3905.3905-.3905 1.0235 0 1.414a.9997.9997 0 0 0 1.4141 0L12 13.4141l2.293 2.2929a.9996.9996 0 0 0 1.414 0 .9996.9996 0 0 0 0-1.414L13.4141 12l2.2929-2.293a.9997.9997 0 0 0 0-1.414"
  />,
  'DeclineTickets',
  24
);

export const DesktopIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M12 6c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1" />
      <path d="M21 0H3a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7v2H5v2h14v-2h-5v-2h7a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3m1 16H2V3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Desktop',
  24
);

export const DiplomaIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M7 20.5c0 1.193-1.194 1.447-1.54 1.496C4.651 21.974 4 21.313 4 20.5V2h9V0H3c-.552 0-1 .448-1 1v19.5C2 22.43 3.57 24 5.5 24h15c1.93 0 3.5-1.57 3.5-3.5V19H7z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M19 12c-1.487 0-2.865-.47-4-1.264V17l4-3 4 3v-6.264C21.865 11.53 20.487 12 19 12m0-2c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"
      key="1"
    />,
  ],
  'Diploma',
  24
);

export const DiscountTicketsIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M22.5 2c.828 0 1.5.672 1.5 1.5v5.5049c-1.65 0-3 1.3485-3 3 .0002 1.6498 1.3501 3 3 3V20.5c0 .828-.672 1.5-1.5 1.5h-21C.672 22 0 21.328 0 20.5v-5.4951c1.6499 0 2.9998-1.3502 3-3 0-1.65-1.35-3-3-3V3.5C0 2.672.672 2 1.5 2zm-8 12c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m1.207-5.707a.9996.9996 0 0 0-1.414 0l-6 6a.9996.9996 0 0 0 0 1.414.9997.9997 0 0 0 1.414 0l6-6a.9997.9997 0 0 0 0-1.414M9.5 7C8.6716 7 8 7.6716 8 8.5S8.6716 10 9.5 10 11 9.3284 11 8.5 10.3284 7 9.5 7"
  />,
  'DiscountTickets',
  24
);

export const DonateIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M20.0409 1.974a3.2412 3.2412 0 0 0-5.041.514 3.2398 3.2398 0 0 0-5.041-.514 3.362 3.362 0 0 0 0 4.7L15 11.8l5.043-5.123a3.3657 3.3657 0 0 0-.002-4.703M20 16h-3.3a8.8 8.8 0 0 1 .266 2.011 1 1 0 0 1-1 .989H7v-2h8a4 4 0 0 0-1.1716-2.8284A4 4 0 0 0 11 13H7c-1.2-1.711-3.695-2-4.9-2H0v8.5l8.192 3.763a4.388 4.388 0 0 0 3.248.268L24 19.667S23.208 16 20 16"
  />,
  'Donate',
  24
);

export const DownloadDataIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 20c-.5523 0-1-.4477-1-1v-4H2v4c0 1.6569 1.3432 3 3 3h4v-2zm10 2h4c1.6569 0 3-1.3431 3-3v-4h-2v4c0 .5523-.4477 1-1 1h-4zm7-13V5c0-1.6568-1.3431-3-3-3h-4v2h4c.5523 0 1 .4477 1 1v4zM4 9V5c0-.5523.4477-1 1-1h4V2H5C3.3432 2 2 3.3432 2 5v4zm7-3v11h2V6z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m16.2425 11.3431-4.2426 4.2427-4.2427-4.2427-1.4142 1.4142L12 18.4142l5.6568-5.6569z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'DownloadData',
  24
);

export const DownloadIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M19 22H5c-1.654 0-3-1.346-3-3v-4h2v4c0 .551.449 1 1 1h14c.551 0 1-.449 1-1v-4h2v4c0 1.654-1.346 3-3 3"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m17.0001 8.586-4 4V2h-2v10.586l-4-4L5.586 10 12 16.414 18.4141 10z"
      key="1"
    />,
  ],
  'Download',
  24
);

export const DropdownCircleIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="currentColor"
        d="M12 0c6.6274 0 12 5.3726 12 12s-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0M7.207 10c-.4453.0001-.6684.5385-.3535.8535l4.4395 4.4395c.3905.3904 1.0235.3904 1.414 0l4.4395-4.4395c.3149-.315.0919-.8534-.3535-.8535z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'DropdownCircle',
  24
);

export const DropupCircleIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="currentColor"
        d="M12 0c6.6274 0 12 5.3726 12 12s-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0m.707 8.707c-.3905-.3904-1.0235-.3904-1.414 0l-4.4395 4.4395c-.3149.315-.0918.8534.3535.8535h9.586c.4454-.0001.6684-.5385.3535-.8535z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'DropupCircle',
  24
);

export const DuplicateIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M7 18H4.5C3.122 18 2 16.878 2 15.5v-11C2 3.122 3.122 2 4.5 2h11C16.878 2 18 3.122 18 4.5V7h-2V4.5c0-.276-.224-.5-.5-.5h-11c-.276 0-.5.224-.5.5v11c0 .276.224.5.5.5H7z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M19.5 6h-11C7.122 6 6 7.122 6 8.5v11C6 20.878 7.122 22 8.5 22h11c1.378 0 2.5-1.122 2.5-2.5v-11C22 7.122 20.878 6 19.5 6M18 15h-3v3h-2v-3h-3v-2h3v-3h2v3h3z"
      key="1"
    />,
  ],
  'Duplicate',
  24
);

export const EasterIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M20.9648 9.8965c.2491.8761.4173 1.7597.4913 2.6211l-2.4668.9551a21 21 0 0 1-13.9786 0l-2.4687-.9336c.073-.8681.241-1.7593.4922-2.6426l1.3105.4619a23.002 23.002 0 0 0 15.3106 0z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M21.4287 14.6953C20.8632 19.6038 16.8412 23 12 23c-4.838 0-8.859-3.3916-9.4287-8.2949l1.7734.6533a23.002 23.002 0 0 0 15.3106 0zM12 1c2.826 0 5.2146 1.9468 6.8359 4.3223.5664.8298 1.057 1.741 1.46 2.6884l-1.3066.462a21 21 0 0 1-13.9786 0l-1.3076-.462c.403-.9476.8945-1.8585 1.461-2.6884C6.7854 2.9468 9.174 1 12 1"
      key="1"
    />,
  ],
  'Easter',
  24
);

export const EditTicketsIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M0 19.5V14h1c1.0977 0 2-.9023 2-2s-.9023-2-2-2H0V4.5C0 3.1197 1.1197 2 2.5 2H14v2H2.5c-.2757 0-.5.2243-.5.5v3.626c1.7216.446 3 2.0167 3 3.874s-1.2785 3.4268-3 3.873V19.5c0 .2757.2243.5.5.5h19c.2757 0 .5-.2243.5-.5v-3.627c-1.7215-.4462-3-2.0158-3-3.873 0-1.8588 1.2786-3.4282 3-3.874V7h2v3h-1c-1.098 0-2 .9011-2 2 0 1.0977.9023 2 2 2h1v5.5c0 1.3803-1.1197 2.5-2.5 2.5h-19C1.1197 22 0 20.8803 0 19.5"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M20.7321 0c-.605 0-1.175.236-1.603.665l-9.129 9.127a.48.48 0 0 0-.106.158L8.04 14.304c-.08.188-.038.405.106.549.096.096.224.146.354.146a.5.5 0 0 0 .196-.04l4.354-1.854a.51.51 0 0 0 .158-.106l9.128-9.128c.428-.429.664-.998.664-1.604 0-.605-.237-1.175-.666-1.603C21.906.236 21.338 0 20.732 0"
      key="1"
    />,
  ],
  'EditTickets',
  24
);

export const EditIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="m13.086 5.5-9.793 9.793c-.109.11-.192.244-.241.391l-2 6c-.12.359-.026.756.241 1.023.19.191.446.293.707.293.105 0 .213-.017.316-.051l6-2c.147-.049.281-.132.391-.242l9.793-9.793zm9.328-1.328-2.586-2.586c-.779-.78-2.049-.78-2.828 0l-2.5 2.5L19.914 9.5l2.5-2.5c.378-.378.586-.88.586-1.414s-.208-1.037-.586-1.414"
  />,
  'Edit',
  24
);

export const EmailOpenIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="currentColor"
        d="M23.972 8.769c-.028-.117-.082-.224-.148-.323-.007-.011-.008-.023-.015-.034-.005-.007-.013-.01-.018-.017-.058-.076-.123-.146-.202-.204l-11.002-8a.998.998 0 0 0-1.177 0l-10.998 8c-.079.058-.145.128-.203.204-.005.007-.013.009-.018.016-.007.01-.008.022-.015.033-.067.1-.121.207-.149.325-.001.006 0 .011-.002.017C.01 8.856 0 8.927 0 9v12c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3V9c0-.073-.01-.143-.025-.213-.001-.006-.001-.012-.003-.018M11.999 2.236 21.3 9l-9.299 6.764L2.7 9z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'EmailOpen',
  24
);

export const EmailIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M13.4 14.6a2.3 2.3 0 0 1-1.4.4 2.3 2.3 0 0 1-1.4-.4L1 8.9V18a3 3 0 0 0 3 3h16a2.9997 2.9997 0 0 0 3-3V8.9z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M20 3H4a3 3 0 0 0-3 3 1.05 1.05 0 0 0 .5.9l10 6a.9.9 0 0 0 .5.1.9.9 0 0 0 .5-.1l10-6A1.05 1.05 0 0 0 23 6a3 3 0 0 0-3-3"
      key="1"
    />,
  ],
  'Email',
  24
);

export const EnterKeyIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M19 12V6c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 1.6569-1.3431 3-3 3H4v-2h14c.5523 0 1-.4477 1-1"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M8.293 8.293a.9996.9996 0 0 1 1.414 0 .9996.9996 0 0 1 0 1.414L5.414 14l4.293 4.293c.3906.3905.3906 1.0235 0 1.414s-1.0235.3905-1.414 0L2.586 14z"
      key="1"
    />,
  ],
  'EnterKey',
  24
);

export const EntranceIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M15 7V1H1v16.515l9 6.428V18h5v-5h-2v3h-3V6.502L5.112 3H13v4z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M18.5 4.586 17.086 6l3 3H12v2h8.086l-3 3 1.414 1.414L23.914 10z"
      key="1"
    />,
  ],
  'Entrance',
  24
);

export const EventGroupIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M15 13h3v3h-3zm0 5h3v3h-3zm5-5h3v3h-3zm0 5h3v3h-3z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M1 5c0-1.6568 1.3432-3 3-3h6.4142l3 3H20c1.6569 0 3 1.3431 3 3v3h-8c-1.1046 0-2 .8954-2 2v8H4c-1.6568 0-3-1.3431-3-3z"
      key="1"
    />,
  ],
  'EventGroup',
  24
);

export const EventImageIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m16.5071 8.3904 6.2792 7.9918L21.5 19.5l-5.0071.5H3.5l-.7567-1.331-1.4866-.338 5.1597-5.7329 3.9556 3.4611z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 3c1.6569 0 3 1.3431 3 3v12c0 1.6569-1.3431 3-3 3H4c-1.6569 0-3-1.3431-3-3V6c0-1.6569 1.3432-3 3-3zm1 3c0-.5523-.4477-1-1-1H4c-.5523 0-1 .4477-1 1v12c0 .5523.4477 1 1 1h16c.5523 0 1-.4477 1-1z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 9c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'EventImage',
  24
);

export const ExchangeTicketsIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M22.5 2c.828 0 1.5.672 1.5 1.5v5.5049c-1.65 0-3 1.3485-3 3 .0002 1.6498 1.3501 3 3 3V20.5c0 .828-.672 1.5-1.5 1.5h-21C.672 22 0 21.328 0 20.5v-5.4951c1.6499 0 2.9998-1.3502 3-3 0-1.65-1.35-3-3-3V3.5C0 2.672.672 2 1.5 2zM6 12.5V18h2v-1.8877c1.0078 1.1561 2.4904 1.8876 4.1455 1.8877 1.6289 0 3.094-.7095 4.0996-1.833l.667-.7451-1.4902-1.334-.667.7451c-.6424.7176-1.5731 1.167-2.6094 1.167-1.1883-.0002-2.237-.594-2.8691-1.5H11.5v-2zM16 7v1.8867C14.9919 7.7308 13.5085 7 11.8535 7c-1.6287.0001-3.093.7096-4.0986 1.833l-.667.7451 1.4902 1.334.667-.7451c.6423-.7176 1.5723-1.1669 2.6084-1.167 1.1886 0 2.2379.5938 2.8701 1.5H12.5v2H18V7z"
  />,
  'ExchangeTickets',
  24
);

export const ExclamationIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 1c6.0751 0 11 4.9249 11 11s-4.9249 11-11 11S1 18.0751 1 12 5.9249 1 12 1m0 14c-.8284 0-1.5.6716-1.5 1.5S11.1716 18 12 18s1.5-.6716 1.5-1.5S12.8284 15 12 15m0-9c-.5523 0-1 .3918-1 .875v5.25c0 .4832.4477.875 1 .875s1-.3918 1-.875v-5.25C13 6.3918 12.5523 6 12 6"
  />,
  'Exclamation',
  24
);

export const ExpandHorizontalIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M3 13h12.5c.5523 0 1-.4477 1-1s-.4477-1-1-1H3c-.5523 0-1 .4477-1 1s.4477 1 1 1"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M11.207 6.293c-.3905-.3906-1.0235-.3906-1.414 0s-.3905 1.0235 0 1.414L14.0859 12l-4.293 4.293c-.3905.3905-.3905 1.0235 0 1.414.3906.3906 1.0236.3906 1.4141 0L16.9141 12zM20 3l.0049-.1025A1.0003 1.0003 0 0 1 21 2c.5177 0 .9438.3933.9951.8975L22 3v18c0 .5523-.4477 1-1 1s-1-.4477-1-1z"
      key="1"
    />,
  ],
  'ExpandHorizontal',
  24
);

export const ExpiredIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.5219 13.971c.7768-1.2947 2.6532-1.2947 3.43 0l4.2337 7.0563c.7999 1.333-.1604 3.029-1.715 3.029h-8.4675c-1.5546 0-2.5148-1.696-1.715-3.029zm2.715 1.5854v4h-2v-4zm.25 6.25c0 .6903-.5596 1.25-1.25 1.25s-1.25-.5597-1.25-1.25.5597-1.25 1.25-1.25 1.25.5596 1.25 1.25"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M11 1c5.5228 0 10 4.4772 10 10 0 .727-.0802 1.4353-.2275 2.1182l-.1055-.1758c-1.5536-2.5894-5.3068-2.5894-6.8604 0L9.5732 19.998a4.1 4.1 0 0 0-.3818.835C4.5322 19.9816 1 15.9051 1 11 1 5.4772 5.4772 1 11 1"
      />
      <path
        fill="#fff"
        d="M12 6c0-.5523-.4477-1-1-1s-1 .4477-1 1v4H7.5c-.5523 0-1 .4477-1 1s.4477 1 1 1H11c.5523 0 1-.4477 1-1z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Expired',
  24
);

export const ExportIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m13.9999 17.0858 4 4 4-4L23.4141 18.5l-5.4142 5.4142L12.5857 18.5z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 20.501h-.002L17 22.5h2V13h-2z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.0784 1a3 3 0 0 0-2.1213.8787L3.8787 6.957A3 3 0 0 0 3 9.0784V20c0 1.6569 1.3431 3 3 3h8.2573l-3.0858-3.0858c-.7811-.7811-.7811-2.0474 0-2.8284l1.4142-1.4143A2 2 0 0 1 15 15.3538V13c0-1.1046.8955-2 2-2h2c1.1001 0 1.9926.888 2 1.9863V4c0-1.6568-1.3431-3-3-3zM11 9H5l6-6z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'Export',
  24
);

export const ExternalLinkIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M22 4c0-1.6568-1.3431-3-3-3H5C3.3431 1 2 2.3432 2 4v16c0 .4632.105.9018.2924 1.2934L11.5858 12H7v-2h8v8h-2v-4.5858l-9.2934 9.2934A2.99 2.99 0 0 0 5 23h14c1.6569 0 3-1.3431 3-3z"
    clipRule="evenodd"
  />,
  'ExternalLink',
  24
);

export const FacebookIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="currentColor"
        d="M24 12c0-6.624-5.376-12-12-12S0 5.376 0 12c0 5.808 4.128 10.644 9.6 11.76V15.6H7.2V12h2.4V9c0-2.316 1.884-4.2 4.2-4.2h3v3.6h-2.4c-.66 0-1.2.54-1.2 1.2V12h3.6v3.6h-3.6v8.34C19.26 23.34 24 18.228 24 12"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Facebook',
  24
);

export const FamilyIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M6.5 7C8.433 7 10 5.433 10 3.5S8.433 0 6.5 0 3 1.567 3 3.5 4.567 7 6.5 7m11 0C19.433 7 21 5.433 21 3.5S19.433 0 17.5 0 14 1.567 14 3.5 15.567 7 17.5 7m0 2a6.49 6.49 0 0 0-5.465 3A3.0003 3.0003 0 0 1 15 15.0173a3.0003 3.0003 0 0 1-3 2.9825 3.0001 3.0001 0 0 1-2.1398-5.1027A3 3 0 0 1 11.965 12a6.4896 6.4896 0 0 0-7.2971-2.7441A6.49 6.49 0 0 0 0 15.5V22a1 1 0 0 0 1 1h7v-2.5l-3.6-2.7a1 1 0 1 1 1.2-1.6L9.333 19h5.334l3.733-2.8a1.0002 1.0002 0 0 1 1.59.9414 1 1 0 0 1-.39.6586L16 20.5V23h7a.9997.9997 0 0 0 1-1v-6.5A6.508 6.508 0 0 0 17.5 9" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Family',
  24
);

export const FeaturedImageIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M17.9999 18h-11a.9999.9999 0 0 1-.707-1.707l7-7c.22-.221.527-.327.84-.284.309.041.581.225.735.495l4 7c.177.31.176.689-.003.998a.998.998 0 0 1-.865.498M7 11c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M21 22H3c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h10c.552 0 1 .447 1 1s-.448 1-1 1H3c-.551 0-1 .448-1 1v14c0 .552.449 1 1 1h18c.551 0 1-.448 1-1v-8c0-.553.448-1 1-1s1 .447 1 1v8c0 1.654-1.346 3-3 3"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M23 4c-1.105 0-2-.895-2-2 0-.552-.448-1-1-1s-1 .448-1 1c0 1.105-.895 2-2 2-.552 0-1 .448-1 1s.448 1 1 1c1.105 0 2 .895 2 2 0 .552.448 1 1 1s1-.448 1-1c0-1.105.895-2 2-2 .552 0 1-.448 1-1s-.448-1-1-1"
      key="2"
    />,
  ],
  'FeaturedImage',
  24
);

export const FestivalIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M16.8 8.3A1.135 1.135 0 0 0 16 8H8.3l7.4 8.3a.908.908 0 0 1 .3.7v7h7a.945.945 0 0 0 .9403-.608A.94.94 0 0 0 24 23v-6a1.85 1.85 0 0 0-.2-.7zM20.5 7a3.5002 3.5002 0 0 0 3.4327-4.1828 3.499 3.499 0 0 0-2.7499-2.75A3.5 3.5 0 0 0 17 3.5 3.51 3.51 0 0 0 20.5 7" />
      <path d="M3.4995 19.5V24h-2.5a.945.945 0 0 1-.3916-.0596.946.946 0 0 1-.5479-.5488.94.94 0 0 1-.0605-.292V17a1.86 1.86 0 0 1 .2002-.7002l6.4004-7.2002 7.3994 8.3008V24h-4.5v-4.5l-3-3z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Festival',
  24
);

export const FileIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.0784 1a3 3 0 0 0-2.1213.8787L3.8787 6.957A3 3 0 0 0 3 9.0784V20c0 1.6569 1.3431 3 3 3h12c1.6569 0 3-1.3431 3-3V4c0-1.6568-1.3431-3-3-3zM11 9H5l6-6z"
    clipRule="evenodd"
  />,
  'File',
  24
);

export const FilterAltIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 7h12M8 17h12"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M18 10.5c1.933 0 3.5-1.567 3.5-3.5S19.933 3.5 18 3.5 14.5 5.067 14.5 7s1.567 3.5 3.5 3.5m-12 10c1.933 0 3.5-1.567 3.5-3.5S7.933 13.5 6 13.5 2.5 15.067 2.5 17s1.567 3.5 3.5 3.5"
      key="1"
    />,
  ],
  'FilterAlt',
  24
);

export const FilterIcon = createSvgIcon(
  <path fill="currentColor" d="M19 11H5v2h14zm4-7H1v2h22zm-8 14H9v2h6z" />,
  'Filter',
  24
);

export const FlashlightIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M16 9.5V19c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4V9.5L6.25 6h11.5zM12 13c-.5523 0-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1v-2c0-.5523-.4477-1-1-1m5-12c.5523 0 1 .4477 1 1v2H6V2c0-.5523.4477-1 1-1z"
  />,
  'Flashlight',
  24
);

export const FolderClosedIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M4 2C2.3432 2 1 3.3432 1 5v13c0 1.6569 1.3432 3 3 3h16c1.6569 0 3-1.3431 3-3V8c0-1.6569-1.3431-3-3-3h-6.5858l-3-3z"
  />,
  'FolderClosed',
  24
);

export const FolderEditIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m16 21.5 6-6c.8284-.8284.8284-2.1716 0-3s-2.1716-.8284-3 0l-6 6v3z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M1 5c0-1.6568 1.3432-3 3-3h6.4142l3 3H20c1.6569 0 3 1.3431 3 3v2.7229c-1.6157-1.2358-3.9365-1.1148-5.4142.3629L11 17.6716V21H4c-1.6568 0-3-1.3431-3-3z"
      key="1"
    />,
  ],
  'FolderEdit',
  24
);

export const FolderOpenIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M19.9314 19.1142A3 3 0 0 1 17.1459 21H3.5091c-1.7687 0-2.9781-1.7863-2.3212-3.4285L4.2165 10H23.577z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M4 2C2.3432 2 1 3.3432 1 5v7.656l1.3595-3.3988A2 2 0 0 1 4.2165 8H21v-.1765c0-1.6568-1.3431-3-3-3h-5.1385L10.0115 2z"
      key="1"
    />,
  ],
  'FolderOpen',
  24
);

export const GiftcardIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="currentColor"
        d="M24 10c0 .5523-.4477 1-1 1H1c-.5523 0-1-.4477-1-1V8c0-1.1046.8954-2 2-2h20c1.1046 0 2 .8954 2 2z"
      />
      <g>
        <path
          fill="currentColor"
          d="M22 6h-1.395A3.69 3.69 0 0 0 21 4.467 3.6003 3.6003 0 0 0 17.333 1 6.213 6.213 0 0 0 12 4.517 6.184 6.184 0 0 0 6.7 1h-.114A3.594 3.594 0 0 0 3 4.467v.066A3.56 3.56 0 0 0 3.379 6H2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1m-4.636-3A1.6 1.6 0 0 1 19 4.467 1.588 1.588 0 0 1 17.425 6h-3.947c.622-1.259 1.859-3 3.886-3M5 4.5A1.6 1.6 0 0 1 6.614 3c2.069.008 3.281 1.731 3.91 3h-3.9A1.616 1.616 0 0 1 5 4.5"
        />
      </g>
      <path
        fill="currentColor"
        d="M23 13c.5523 0 1 .4477 1 1v7c0 1.1046-.8954 2-2 2H2c-1.1046 0-2-.8954-2-2v-7c0-.5523.4477-1 1-1zM4.5 17a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm11 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Giftcard',
  24
);

export const GlobeConnectIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M9.36 1.3189C4.873 2.424 1.4699 6.2827 1.0448 11h4.5734c.2019-3.4505 1.449-6.8509 3.7418-9.6811M5.6182 13H1.0448c.4251 4.7173 3.8283 8.5759 8.3152 9.6812C7.0673 19.8509 5.82 16.4505 5.6182 13M18.5 12.586 17.086 14l3 3H13v2h7.086l-3 3 1.414 1.414L23.914 18z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m14.2577 14.0005 1 1h-4.2578v6h2.414a15.06 15.06 0 0 1-1.414 1.624c-2.6858-2.6725-4.1452-6.1157-4.378-9.625h7.6368zM7.6222 11C7.8549 7.4907 9.3142 4.048 12 1.3756 14.6858 4.048 16.1451 7.4906 16.3778 11zM14.64 1.3189C16.9327 4.149 18.1799 7.5495 18.3817 11h4.5735c-.4251-4.7173-3.8284-8.5759-8.3152-9.6811"
      key="1"
    />,
  ],
  'GlobeConnect',
  24
);

export const GlobeIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M9.36 1.3189C4.873 2.424 1.4699 6.2827 1.0448 11h4.5734c.2019-3.4505 1.449-6.8509 3.7418-9.6811M12 22.6245C9.3142 19.952 7.855 16.5093 7.6222 13h8.7556c-.2327 3.5093-1.692 6.952-4.3778 9.6245M5.6182 13H1.0448c.4251 4.7173 3.8283 8.5759 8.3152 9.6812C7.0673 19.8509 5.82 16.4505 5.6182 13m12.7635 0c-.2018 3.4505-1.449 6.8509-3.7417 9.6812 4.4868-1.1053 7.8901-4.9639 8.3152-9.6812zM7.6222 11C7.8549 7.4907 9.3142 4.048 12 1.3756 14.6858 4.048 16.1451 7.4906 16.3778 11zM14.64 1.3189C16.9327 4.149 18.1799 7.5495 18.3817 11h4.5735c-.4251-4.7173-3.8284-8.5759-8.3152-9.6811"
  />,
  'Globe',
  24
);

export const GoogleIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M22.0575 12.222c0-.8222-.0683-1.4222-.216-2.0444h-9.6081v3.7111h5.6397c-.1136.9223-.7276 2.3111-2.0921 3.2444l-.0192.1243 3.0379 2.2997.2105.0206c1.9329-1.7445 3.0473-4.3112 3.0473-7.3557"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12.2332 22c2.763 0 5.0825-.889 6.7768-2.4223l-3.2292-2.4445c-.8642.5889-2.024 1-3.5476 1-2.7062 0-5.003-1.7444-5.8217-4.1555l-.12.01-3.1589 2.3889-.0413.1122C4.7741 19.7554 8.2307 22 12.2332 22"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M6.4117 13.9768c-.216-.6222-.341-1.2889-.341-1.9778s.125-1.3556.3296-1.9778l-.0057-.1325-3.1984-2.4273-.1047.0487C2.398 8.8656 2 10.388 2 11.999s.398 3.1334 1.0915 4.4889z"
      key="2"
    />,
    <path
      fill="currentColor"
      d="M12.2332 5.8667c1.9216 0 3.2178.811 3.9569 1.4889L19.0782 4.6c-1.7738-1.611-4.082-2.6-6.845-2.6-4.0025 0-7.459 2.2444-9.1419 5.5111l3.3088 2.5112c.8301-2.4112 3.127-4.1556 5.8331-4.1556"
      key="3"
    />,
  ],
  'Google',
  24
);

export const GoupObjectsIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M4 17c-1.6568 0-3 1.3431-3 3s1.3432 3 3 3 3-1.3431 3-3-1.3431-3-3-3m8 0c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3-1.3431-3-3-3m0-16c-1.6569 0-3 1.3432-3 3s1.3431 3 3 3 3-1.3431 3-3-1.3431-3-3-3m8 16c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3-1.3431-3-3-3m-7-6h5c1.6569 0 3 1.3431 3 3v1h-2v-1c0-.5523-.4477-1-1-1h-5v2h-2v-2H6c-.5523 0-1 .4477-1 1v1H3v-1c0-1.6569 1.3431-3 3-3h5V9h2z"
  />,
  'GoupObjects',
  24
);

export const HallIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M18.667 4H5.333L0 0v20l5.333-4h13.334L24 20V0zM4 14.5 2 16V4l2 1.5zM22 16l-2-1.5v-9L22 4z" />
      <path d="M19 18H5v2h14zm5 4H0v2h24z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Hall',
  24
);

export const HapticsIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M19.9991 11.9998a4 4 0 0 1-1.1709 2.8281c-.3904.3905-1.0234.3902-1.414 0-.3905-.3904-.3912-1.0235-.001-1.4141a2 2 0 0 0 .5859-1.414c0-.5304-.211-1.0391-.5859-1.4141-.3903-.3906-.3896-1.0237.001-1.414.3905-.3904 1.0236-.3906 1.414 0a4 4 0 0 1 1.1709 2.8281" />
      <path d="M24.0003 12.0007a8.004 8.004 0 0 1-2.3438 5.6573c-.3905.3901-1.0236.3903-1.4141 0-.3905-.3906-.3905-1.0246 0-1.4151a6 6 0 0 0 1.7579-4.2422 6 6 0 0 0-1.7579-4.2431c-.3903-.3905-.3903-1.0236 0-1.414.3905-.3906 1.0236-.3905 1.4141 0a8 8 0 0 1 1.7344 2.5956 8 8 0 0 1 .6094 3.0615m-19.9994.001a4 4 0 0 1 1.1709-2.8281c.3904-.3905 1.0235-.3903 1.414 0 .3906.3904.3912 1.0234.001 1.414a2 2 0 0 0-.5859 1.4141c0 .5303.211 1.039.586 1.4141.3902.3906.3895 1.0236-.001 1.414s-1.0237.3906-1.4141 0a4 4 0 0 1-1.1709-2.8281" />
      <path d="M-.0002 12.0007a8.002 8.002 0 0 1 2.3438-5.6572c.3904-.3902 1.0236-.3904 1.414 0 .3905.3906.3905 1.0245 0 1.415a5.9993 5.9993 0 0 0 0 8.4854c.3903.3905.3903 1.0236 0 1.4141-.3905.3905-1.0235.3904-1.414 0a8.002 8.002 0 0 1-2.3438-5.6573m7-12.0009h10a3 3 0 0 1 2.1211.8789 3 3 0 0 1 .8789 2.121v1c0 .5523-.4478 1-1 1s-1-.4477-1-1v-1a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1v1c0 .5523-.4478 1-1 1s-1-.4477-1-1v-1c0-.7956.3162-1.5584.8789-2.121a3 3 0 0 1 2.121-.879m10.0001 24.0001h-10a3 3 0 0 1-2.1211-.879 3 3 0 0 1-.879-2.121v-1c0-.5523.4478-1 1-1s1 .4477 1 1v1a1 1 0 0 0 1 1h10.0001a1 1 0 0 0 1-1v-1c0-.5523.4477-1 1-1s1 .4477 1 1v1a3 3 0 0 1-.8789 2.121 3 3 0 0 1-2.1211.879M12 14c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Haptics',
  24
);

export const HeatIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="m11.8054 1 .2539.1709c2.11 1.4234 2.8296 3.4865 3.0283 5.1162.0992.8135.0727 1.5374.0215 2.0576-.0623.6338-.2206 1.241-.3672 1.8594A3.807 3.807 0 0 0 17.03 6.4639L16.9998 6c1.9442 1.7599 4.1708 5.4448 3.9941 9.5957-.1274 3.0416-1.6582 5.9924-4.582 7.3154L16.2156 23h-.7158v-1c-.1249-2.4842-1.3438-4.7538-3.5-6h-.5c0 3.1749-2.818 3.4716-3 6v1H7.739l-.2265-.127c-2.814-1.5727-4.5368-4.7631-4.5127-7.955-.0252-3.3168 1.9267-5.464 3.621-7.2793 1.7745-1.901 3.235-3.4267 3.374-5.6992L10.0526 1z"
  />,
  'Heat',
  24
);

export const HelpIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1m0 17.5c-.689 0-1.25-.561-1.25-1.25S11.311 16 12 16s1.25.561 1.25 1.25-.561 1.25-1.25 1.25m2.19-6.482c-.702.518-1.087.829-1.2 1.515l.005.968h-2.133l.13-1.124c.205-1.639 1.25-2.407 2.014-2.969.774-.57 1.148-.881 1.177-1.715.044-1.317-.948-1.646-1.788-1.688-1.092-.059-1.901.549-2.184 1.619l-.253.967-1.935-.507.254-.968c.522-1.995 2.18-3.218 4.22-3.109 2.311.119 3.757 1.593 3.684 3.755-.062 1.839-1.176 2.659-1.99 3.257z"
  />,
  'Help',
  24
);

export const HideIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="m9.627 14.373 6.747-6.747c-.848-1.556-2.48-2.627-4.373-2.627-2.757 0-5 2.243-5 5 0 1.894 1.071 3.525 2.627 4.373z" />
      <path d="M6.021 18.345C2.249 16.167.338 12.618.258 12.468l-.253-.477.261-.474C.435 11.21 4.496 4 12 4c2.064 0 4.076.557 5.979 1.655l-1 1.732C15.384 6.467 13.709 6 12 6c-5.29 0-8.702 4.512-9.688 6.009.615.962 2.21 3.162 4.709 4.604zM12 20c-.463 0-.93-.028-1.388-.084l-.992-.122.243-1.985.993.122c.377.046.762.07 1.144.07 5.313 0 8.732-4.552 9.701-6.028-.302-.502-.879-1.358-1.767-2.261l-.701-.713 1.427-1.402.7.713c1.638 1.667 2.373 3.2 2.403 3.265l.219.462-.247.448c-.17.307-4.231 7.517-11.735 7.517z" />
      <path d="M21.9995.5859.5855 21.9999l1.4142 1.4142 21.414-21.414z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Hide',
  24
);

export const HistoryIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M11 6h2v5.5859L17.4141 16 16 17.4141l-5-5zM2.5 2.5h2v4h4v2h-6z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M1.5 12v-1h2v1c0 4.6944 3.8056 8.5 8.5 8.5s8.5-3.8056 8.5-8.5-3.8056-8.5-8.5-8.5c-3.2363 0-6.0517 1.8086-7.4883 4.4746l-.0058.0098-1.755-.959c.019-.0352.0393-.0696.0587-.1045l.0517-.0947.4844-.874.0518.0283C5.2953 3.2732 8.4395 1.5 12 1.5c5.799 0 10.5 4.701 10.5 10.5S17.799 22.5 12 22.5 1.5 17.799 1.5 12"
      key="1"
    />,
  ],
  'History',
  24
);

export const HomeIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M18 10c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4M6 10c2.2091 0 4-1.7909 4-4S8.2091 2 6 2 2 3.7909 2 6s1.7909 4 4 4m12 12c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4M6 22c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4"
  />,
  'Home',
  24
);

export const House61Icon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m22.3669 11.774-10.367-8.482-10.367 8.482-1.266-1.548L12 .708l11.633 9.518z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m12 5.876-8 6.546V20c0 1.654 1.346 3 3 3h4v-5h2v5h4c1.654 0 3-1.346 3-3v-7.578z"
      key="1"
    />,
  ],
  'House61',
  24
);

export const HouseIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m22.3669 11.774-10.367-8.482-10.367 8.482-1.266-1.548L12 .708l11.633 9.518z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m12 5.876-8 6.546V20c0 1.654 1.346 3 3 3h4v-5h2v5h4c1.654 0 3-1.346 3-3v-7.578z"
      key="1"
    />,
  ],
  'House',
  24
);

export const InfoSimpleIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M11 20V10c0-.5523.4477-1 1-1s1 .4477 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1m1-14c.8284 0 1.5-.6716 1.5-1.5S12.8284 3 12 3s-1.5.6716-1.5 1.5S11.1716 6 12 6"
  />,
  'InfoSimple',
  24
);

export const InfoIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 1c6.0751 0 11 4.9249 11 11s-4.9249 11-11 11S1 18.0751 1 12 5.9249 1 12 1m0 10c-.5523 0-1 .3918-1 .875v5.25c0 .4832.4477.875 1 .875s1-.3918 1-.875v-5.25c0-.4832-.4477-.875-1-.875m0-5c-.8284 0-1.5.6716-1.5 1.5S11.1716 9 12 9s1.5-.6716 1.5-1.5S12.8284 6 12 6"
  />,
  'Info',
  24
);

export const InstagramIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M23.9227 7.0955a8.7 8.7 0 0 0-.5584-2.9533A6.144 6.144 0 0 0 19.8552.633a8.8 8.8 0 0 0-2.9134-.5598C15.6597.016 15.2532 0 11.9987 0S8.327 0 7.0542.0733a8.8 8.8 0 0 0-2.912.5598A6.14 6.14 0 0 0 .633 4.142a8.74 8.74 0 0 0-.5585 2.9121C.0173 8.3376 0 8.7442 0 11.9987s0 3.6703.0746 4.9444c.02.9969.208 1.9805.5585 2.9147a6.144 6.144 0 0 0 3.5104 3.5078 8.78 8.78 0 0 0 2.912.5997c1.2835.0574 1.69.0747 4.9445.0747 3.2546 0 3.6717 0 4.9445-.0747a8.78 8.78 0 0 0 2.9133-.5584 6.15 6.15 0 0 0 3.5091-3.5091 8.78 8.78 0 0 0 .5585-2.9147c.0573-1.2821.0746-1.6886.0746-4.9444-.0027-3.2546-.0027-3.6677-.0773-4.9432m-11.932 11.0578c-3.4038 0-6.1613-2.7575-6.1613-6.1613s2.7575-6.1613 6.1613-6.1613a6.1611 6.1611 0 0 1 4.3566 10.518 6.16 6.16 0 0 1-4.3566 1.8046m6.4065-11.1138a1.435 1.435 0 0 1-1.0163-.4204 1.434 1.434 0 0 1-.4204-1.0163 1.435 1.435 0 0 1 .4206-1.0154 1.435 1.435 0 0 1 1.5649-.3113 1.435 1.435 0 0 1 .7772.7772c.0722.1742.1093.361.1093.5495 0 .7944-.6424 1.4367-1.4353 1.4367" />
      <path d="M11.9907 15.9942c2.2104 0 4.0023-1.7919 4.0023-4.0022s-1.7919-4.0023-4.0023-4.0023-4.0022 1.7919-4.0022 4.0023 1.7919 4.0022 4.0022 4.0022" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Instagram',
  24
);

export const KeyboardIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M23 9H1c-.552 0-1 .448-1 1v12c0 .552.448 1 1 1h22c.552 0 1-.448 1-1V10c0-.552-.448-1-1-1M8 13h3v2H8zm-2 6H3v-2h3zm0-4H3v-2h3zm10 4H8v-2h8zm0-4h-3v-2h3zm5 4h-3v-2h3zm0-4h-3v-2h3zM12 .6c.211 0 .422.067.6.2l4.8 3.6L16.2 6 12 2.85 7.8 6 6.6 4.4 11.4.8c.178-.133.389-.2.6-.2"
  />,
  'Keyboard',
  24
);

export const KioskIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 9c1.3807 0 2.5-1.1193 2.5-2.5S13.3807 4 12 4 9.5 5.1193 9.5 6.5 10.6193 9 12 9m4.066 3.233c-.112-.563-.453-1.048-.936-1.33-2.047-1.195-4.214-1.195-6.263 0-.481.281-.822.766-.935 1.329l-1.063 5.32 2.189 1.095.535 5.352h4.811l.535-5.352 2.189-1.095-1.063-5.32z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M2 24V3c0-1.1046.8954-2 2-2h16c1.1046 0 2 .8954 2 2v21"
      key="1"
    />,
  ],
  'Kiosk',
  24
);

export const LaptopIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M22 15h-2V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10H2V5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12 8c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1m12 9a4 4 0 0 1-1.1716 2.8284A4 4 0 0 1 20 21H4a4 4 0 0 1-4-4z"
      key="1"
    />,
  ],
  'Laptop',
  24
);

export const LaunchIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M15.5 10c.8284 0 1.5-.6716 1.5-1.5S16.3284 7 15.5 7 14 7.6716 14 8.5s.6716 1.5 1.5 1.5" />
      <path d="m23.0981.902-1.184.102c-5.124.44-9.323 2.191-12.292 4.996h-2.66c-.916 0-1.771.411-2.344 1.128L.034 12.867l5.809 1.39 3.899 3.899 1.389 5.81 5.74-4.584c.717-.572 1.128-1.427 1.128-2.345v-2.659c2.805-2.969 4.555-7.169 4.996-12.293l.102-1.184zm-12.162 15.62-3.457-3.457c1.109-3.472 4.291-8.746 13.395-9.937-1.191 9.104-6.466 12.285-9.938 13.394" />
      <path d="m4.529 15.771-.571.283c-.425.21-.822.499-1.181.858-1.374 1.373-1.735 4.622-1.772 4.987l-.122 1.217 1.217-.122c.366-.037 3.614-.399 4.988-1.772.359-.36.648-.757.858-1.181l.282-.571-3.7-3.7z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Launch',
  24
);

export const LayoutCollapsedIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M20 3H4C2.346 3 1 4.346 1 6v12c0 1.654 1.346 3 3 3h16c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3M8 19H6V5h2z"
  />,
  'LayoutCollapsed',
  24
);

export const LightmodeIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M13 0h-2v4h2zm6.7776 2.8078-2.8284 2.8284 1.4142 1.4142 2.8285-2.8284zM24 11h-4v2h4zm-5.6356 5.9497-1.4142 1.4142 2.8284 2.8284 1.4142-1.4142zM13 20h-2v4h2zm-7.3643-3.0504L2.8073 19.778l1.4142 1.4142 2.8284-2.8284zM4 11H0v2h4zm.2216-8.1923L2.8074 4.222l2.8284 2.8285L7.05 5.636zM12 18c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6-6 2.6863-6 6 2.6863 6 6 6" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Lightmode',
  24
);

export const Linkedin1Icon = createSvgIcon(
  <path
    fill="currentColor"
    d="M4.4037 6.8075c1.3276 0 2.4038-1.0762 2.4038-2.4038S5.7313 2 4.4037 2 2 3.0762 2 4.4037s1.0762 2.4038 2.4037 2.4038m4.6735 1.8213v13.3359h4.1406v-6.5949c0-1.7401.3274-3.4254 2.485-3.4254 2.128 0 2.1544 1.9896 2.1544 3.5353v6.4861H22v-7.3133c0-3.5925-.7734-6.3532-4.9723-6.3532-2.0159 0-3.3672 1.1062-3.9198 2.1532h-.056V8.6288zm-6.7476 0h4.1472v13.3359H2.3296z"
  />,
  'Linkedin1',
  24
);

export const LinkedinIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M20.8889 2H3.1111A1.111 1.111 0 0 0 2 3.1111V20.889A1.111 1.111 0 0 0 3.1111 22H20.889c.2947 0 .5773-.1171.7857-.3254A1.112 1.112 0 0 0 22 20.8889V3.1111A1.1114 1.1114 0 0 0 20.8889 2M7.9322 19.0411H4.9633V9.4967h2.969zM6.4478 8.1933a1.72 1.72 0 1 1 0-3.44 1.72 1.72 0 0 1 0 3.44m12.5944 10.8478h-2.9655V14.4c0-1.1067-.02-2.53-1.5423-2.53-1.5444 0-1.7788 1.2067-1.7788 2.4522v4.72H9.7922V9.4978h2.8445v1.3044h.0411c.3944-.75 1.3633-1.541 2.8044-1.541 3.0045 0 3.5589 1.9755 3.5589 4.5466z"
  />,
  'Linkedin',
  24
);

export const LockedIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M20 8H4c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h16c1.105 0 2-.895 2-2V10c0-1.105-.895-2-2-2m-8 10c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2" />
      <path d="M18 11h-2V6c.023-2.184-1.727-3.974-3.911-4h-.042C9.85 1.962 8.038 3.711 8 5.908V11H6V5.9C6.033 2.636 8.685.006 11.949 0h.061c3.302-.006 5.984 2.666 5.99 5.968z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Locked',
  24
);

export const LogoIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="m22.908 20.581-6-13c-.148-.32-.453-.538-.803-.575a.996.996 0 0 0-.905.394l-5.4 7.2-3.2-2.4a1.002 1.002 0 0 0-.83-.174c-.289.068-.532.261-.665.526l-4 8c-.155.31-.138.678.044.973A1 1 0 0 0 2 22h20a.999.999 0 0 0 .842-.461.999.999 0 0 0 .066-.958M8 8c1.6569 0 3-1.3431 3-3S9.6569 2 8 2 5 3.3432 5 5s1.3431 3 3 3"
  />,
  'Logo',
  24
);

export const MapPinIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 0C9.243 0 7 2.243 7 5c0 2.301 1.446 4.449 4.42 6.565l.58.412.58-.412C15.554 9.449 17 7.301 17 5c0-2.757-2.243-5-5-5m0 6.5c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 1.5.672 1.5 1.5-.672 1.5-1.5 1.5M5.4184 2.6138 1 4.313v17.643l6-2.3077v-9.4194c-1.2656-1.561-2-3.2913-2-5.229 0-.8376.1477-1.6412.4184-2.3861M17 10.2289v11.7656l6-2.3077V2.0439l-4.1337 1.59c.0877.4419.1337.8987.1337 1.366 0 1.9378-.7344 3.668-2 5.229m-6.7395 2.9658.5813.4128a2 2 0 0 0 2.3164 0l.5813-.4128A21 21 0 0 0 15 12.2263v10.1418l-6-3v-7.1418c.397.3309.818.6535 1.2605.9684"
  />,
  'MapPin',
  24
);

export const MegaphoneIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M20 9a2.9904 2.9904 0 0 0-2.658-2.966A12.55 12.55 0 0 0 17 9a12.55 12.55 0 0 0 .342 2.9661A2.99 2.99 0 0 0 20 9.0001m-8.333 8.9109-5.788-1.845 2.632 6.475a2.329 2.329 0 0 0 3.031 1.29 2.33 2.33 0 0 0 .7606-.4975 2.33 2.33 0 0 0 .6981-1.6404 2.33 2.33 0 0 0-.1687-.8931z" />
      <path d="M19.0001 0a3.13 3.13 0 0 0-1.054.185L2.7301 5.037A3.818 3.818 0 0 0 0 9a3.809 3.809 0 0 0 2.7 3.953l15.25 4.862c.3368.1212.692.1838 1.05.185 2.851 0 5-3.869 5-9s-2.149-9-5-9m0 16c-1.416 0-3-2.994-3-7s1.584-7 3-7 3 2.994 3 7-1.584 7-3 7" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Megaphone',
  24
);

export const MembershipRenewalOnIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M21 0c1.6569 0 3 1.3432 3 3v10.7568l-2-1.999-6 6-3-3L8.7578 19l1 1H3c-1.6568 0-3-1.3431-3-3V3c0-1.6568 1.3432-3 3-3zM7 11c-1.657 0-3 1.343-3 3h8c0-1.657-1.343-3-3-3zm1-5c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m7 1c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1z" />
      <path
        fillRule="evenodd"
        d="M23.4142 16 16 23.4142 11.5858 19 13 17.5858l3 3 6-6z"
        clipRule="evenodd"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'MembershipRenewalOn',
  24
);

export const MembershipRenewalIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M21 0c1.6569 0 3 1.3432 3 3v7h-4v.7705a7.5 7.5 0 0 0-2-.2705c-2.474 0-4.6681 1.1983-6.0342 3.0459C11.747 12.1044 10.5026 11 9 11H7c-1.657 0-3 1.343-3 3h7.6572A7.46 7.46 0 0 0 10.5 18c0 .6928.0956 1.3631.2715 2H3c-1.6568 0-3-1.3431-3-3V3c0-1.6568 1.3432-3 3-3zM8 6c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m7 1c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1z" />
      <path fillRule="evenodd" d="M24 12v6h-6v-2h4v-4z" clipRule="evenodd" />
      <path
        fillRule="evenodd"
        d="M14.5 18c0-1.9327 1.5673-3.5 3.5-3.5 1.2728 0 2.3877.6796 3 1.6958V17h2.4133l-.05-.2209C22.8083 14.3292 20.6191 12.5 18 12.5c-3.0373 0-5.5 2.4627-5.5 5.5s2.4627 5.5 5.5 5.5a5.48 5.48 0 0 0 3.3007-1.1005l.7995-.6007-1.2014-1.599-.7995.6007A3.48 3.48 0 0 1 18 21.5c-1.9327 0-3.5-1.5673-3.5-3.5"
        clipRule="evenodd"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'MembershipRenewal',
  24
);

export const MembershipIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M21 2c1.6569 0 3 1.3432 3 3v14c0 1.6569-1.3431 3-3 3H3c-1.6568 0-3-1.3431-3-3V5c0-1.6568 1.3432-3 3-3zM7 13c-1.657 0-3 1.343-3 3h8c0-1.657-1.343-3-3-3zm8 0c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1zM8 8c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m7 1c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
  />,
  'Membership',
  24
);

export const MenuIcon = createSvgIcon(
  <path fill="currentColor" d="M23 11v2H1v-2zm0-7v2H1V4zm0 14v2H1v-2z" />,
  'Menu',
  24
);

export const MicrophoneIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m2 19.5858 1.207 1.2071L4.4141 22 3 23.4142l-1.207-1.2071L.5856 21zm8.7928-16.2781c2.7337-2.7337 7.1658-2.7337 9.8995 0s2.7337 7.1658 0 9.8995-7.1658 2.7336-9.8995 0-2.7337-7.1658 0-9.8995"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M7.479 11.8289 2.5 17.9143l3.5858 3.5858 6.0854-4.979c-1.0141-.4379-1.964-1.0711-2.7925-1.8996S7.9169 12.843 7.479 11.8289"
      key="1"
    />,
  ],
  'Microphone',
  24
);

export const MoneyBillsIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M3 2h18v2H3zM0 6v16h24V6zm12 11c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3m-6 0H3v2h3zm12-6V9h3v2z"
    clipRule="evenodd"
  />,
  'MoneyBills',
  24
);

export const MoreIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 13.75c.9665 0 1.75-.7835 1.75-1.75s-.7835-1.75-1.75-1.75-1.75.7835-1.75 1.75.7835 1.75 1.75 1.75m0-7.25c.9665 0 1.75-.7835 1.75-1.75S12.9665 3 12 3s-1.75.7835-1.75 1.75S11.0335 6.5 12 6.5M12 21c.9665 0 1.75-.7835 1.75-1.75S12.9665 17.5 12 17.5s-1.75.7835-1.75 1.75S11.0335 21 12 21"
  />,
  'More',
  24
);

export const MusicIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M21.947 9.679C19.906 3.662 14.289 2.364 12 2.082V0h-2v15.026C9.162 14.391 8.13 14 7 14c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5V9.007c1.851.05 5.929.339 8.491 1.854.158.093.334.139.509.139.225 0 .448-.076.63-.224a.9975.9975 0 0 0 .317-1.097"
  />,
  'Music',
  24
);

export const NearMeIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 24c-5.333 0-11-1.752-11-5 0-1.748 1.648-3.2139 4.641-4.1309l.956-.2931.586 1.913-.956.292C3.998 17.464 3 18.387 3 19c0 1.223 3.506 3 9 3s9-1.777 9-3c0-.612-.998-1.536-3.227-2.219l-.956-.292.586-1.913.956.2931C21.351 15.7861 23 17.252 23 19c0 3.248-5.667 5-11 5m0-19c1.3807 0 2.5-1.1193 2.5-2.5S13.3807 0 12 0 9.5 1.1193 9.5 2.5 10.6193 5 12 5"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M16.066 8.233c-.112-.563-.453-1.048-.936-1.33-2.047-1.195-4.214-1.195-6.263 0-.481.281-.822.766-.935 1.329l-1.063 5.32 2.189 1.095.535 5.352h4.811l.535-5.352 2.189-1.095-1.063-5.32z"
      key="1"
    />,
  ],
  'NearMe',
  24
);

export const NewSeatsIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M18 15c.808 0 1.573.331 2.131.893l-1.608 1.168 4.269.939.428-4.351-1.466 1.065C20.814 13.644 19.451 13 18 13c-2.282 0-4.273 1.542-4.843 3.75l1.938.499C15.436 15.925 16.63 15 18 15m0 7c-.808 0-1.573-.331-2.131-.893l1.608-1.168L13.208 19l-.428 4.351 1.466-1.065C15.186 23.356 16.549 24 18 24c2.282 0 4.273-1.542 4.843-3.75l-1.938-.499C20.564 21.075 19.37 22 18 22m-4.2393-10c-1.8317 1.056-3.1763 2.8618-3.6103 5H9v4H7v-4H5v5H3v-7c0-1.6569 1.3431-3 3-3zM16 2c1.6569 0 3 1.3432 3 3v5.0996A5.02 5.02 0 0 0 18 10H6c-.3424 0-.677.034-1 .0996V5c0-1.6569 1.3431-3 3-3z"
  />,
  'NewSeats',
  24
);

export const NoteIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M15.0429 22.1213A3 3 0 0 1 12.9216 23H6c-1.6569 0-3-1.3431-3-3V4c0-1.6568 1.3431-3 3-3h12c1.6569 0 3 1.3432 3 3v10.9216a3 3 0 0 1-.8787 2.1213zM19 15h-6v6zM7 10v2h10v-2zm0-4h5v2H7zm7 0v2h3V6z"
    clipRule="evenodd"
  />,
  'Note',
  24
);

export const NotificationIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M20 15V9c0-4.411-3.589-8-8-8S4 4.589 4 9v6c0 1.103-.897 2-2 2v2h20v-2c-1.103 0-2-.897-2-2M8.538 21l.875 1.503C9.95 23.427 10.941 24 12 24s2.05-.573 2.587-1.497L15.462 21z"
  />,
  'Notification',
  24
);

export const Office365Icon = createSvgIcon(
  <path
    fill="currentColor"
    d="M4 18.1335V5.9745L13.5986 2l5.2162 1.8697v16.3679L13.5986 22zl9.5986 1.2944V5.2737l-6.26 1.6369v9.5868z"
  />,
  'Office365',
  24
);

export const OutlookIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M14.5959 16.9299v-5.3066c.377.2598.7305.4999 1.0821.7421.3164.2169.3692.2149.6953-.0019 1.8066-1.2012 3.6132-2.4004 5.42-3.6016.0546-.037.1113-.0703.1914-.119.0058.082.0156.1444.0156.205 0 2.3085.0019 4.6172 0 6.9277 0 .7676-.3888 1.1543-1.1524 1.1543zm.0137-10.6939h6.567c.379 0 .672.2325.7911.5958.0528.1602 0 .2382-.1308.3242-1.6427 1.0997-3.2816 2.2053-4.9224 3.3089-.2344.1583-.4707.3106-.7012.4747-.125.0898-.2383.0937-.3672.0097-.3751-.2421-.756-.4726-1.1291-.7168-.0624-.0411-.1269-.1348-.1269-.2032-.0059-1.2403-.0039-2.4807-.0019-3.721 0-.0156.0077-.0293.0214-.0723M13.6543 22c-3.8887-.8145-7.7617-1.625-11.6484-2.4375v-.2558c0-4.9317.002-9.8634-.0059-14.795 0-.205.0547-.2754.254-.3125 3.1073-.5937 6.2147-1.1953 9.3222-1.7968.6855-.1348 1.371-.2657 2.0781-.4024zm-3.0996-10.0195c-.0078-.8125-.1192-1.5625-.5215-2.2441-.3242-.549-.7617-.9649-1.3926-1.1446-1.2265-.3496-2.3984.2246-2.9765 1.4648-.3692.7949-.4493 1.6387-.377 2.502.0625.748.2793 1.4395.7617 2.0312.959 1.1758 2.7032 1.1836 3.6758.0156.6426-.7733.8184-1.6933.8301-2.6249"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M6.5491 11.9983c-.002-.5801.0762-1.1407.4043-1.6368.3028-.459.7618-.6465 1.2677-.5196.3927.0977.631.377.7892.7266.2695.5997.3164 1.2365.2363 1.8733-.045.3535-.1465.713-.289 1.0391-.1856.4219-.543.6642-1.0197.6739-.4805.0097-.8145-.2383-1.047-.6368-.2754-.4668-.3418-.9864-.3418-1.5197"
      key="1"
    />,
  ],
  'Outlook',
  24
);

export const PaintBucketIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M.9302 11.9628 3.419 8.092l2.5116 1.1592A19 19 0 0 0 13.8927 11H17.5l-.5 2-8.6501 6.7603z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m10.5147.5858 9.8995 9.8995-9.1924 9.1924c-1.1716 1.1716-3.071 1.1716-4.2427 0l-5.6568-5.6569c-1.1716-1.1715-1.1716-3.071 0-4.2426zm0 2.8284-7.7782 7.7782c-.3905.3905-.3905 1.0237 0 1.4142l5.6569 5.6569c.3905.3905 1.0236.3905 1.4142 0l7.7782-7.7782z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M20 15c1.455 1.104 2.5 2.3607 2.5 3.8333S21.3806 21.5 20 21.5s-2.5-1.194-2.5-2.6667c0-1.4726 1.045-2.7293 2.5-3.8333"
      key="2"
    />,
  ],
  'PaintBucket',
  24
);

export const PaintbrushIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m20.8786 5.9706-5.7652 4.203-1.4036-1.4035 4.2031-5.7653c.7678-1.0532 2.2946-1.172 3.2162-.2504s.8027 2.4484-.2505 3.2162"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 4c-.5523 0-1 .4477-1 1v14c0 .5523.4477 1 1 1h14c.5523 0 1-.4477 1-1v-9h2v9c0 1.6569-1.3431 3-3 3H5c-1.6568 0-3-1.3431-3-3V5c0-1.6568 1.3432-3 3-3h9v2z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M9.5272 9.1961c1.7219-1.722 4.0832-1.3597 5.3745-.0683s1.6535 3.6527-.0684 5.3747c-.9512.9512-2.4089 1.2689-3.6977 1.4261-1.036.1263-2.0648.1131-3.1051.0716-.0426-1.0401-.0568-2.0685.0691-3.1044.1568-1.2901.4756-2.7476 1.4276-3.6997"
      key="2"
    />,
  ],
  'Paintbrush',
  24
);

export const PaperPlaneIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M6 23.204v-9.829l4.191 1.465 2.468 2.537z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m.43 9.197 3.483 2.613 8.8711-3.457-6.784 5.022 13.229 9.921L22.7531.973z"
      key="1"
    />,
  ],
  'PaperPlane',
  24
);

export const PhoneAddIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M14 1c1.6569 0 3 1.3432 3 3v5c-4.4183 0-8 3.5817-8 8 0 2.3901 1.0493 4.5341 2.7109 6H4c-1.6568 0-3-1.3431-3-3V4c0-1.6568 1.3432-3 3-3zM7.5606 4C6.975 4 6.5 4.475 6.5 5.0606c.0001.5854.475 1.0605 1.0606 1.0605h2.8789c.5855 0 1.0604-.475 1.0605-1.0606S11.0251 4 10.4395 4z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M17 11c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6m-1 5h-2v2h2v2h2v-2h2v-2h-2v-2h-2z"
      key="1"
    />,
  ],
  'PhoneAdd',
  24
);

export const PhoneCameraIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M20 20c0 1.6569-1.3431 3-3 3H7c-1.6569 0-3-1.3431-3-3V4c0-1.6568 1.3431-3 3-3h10c1.6569 0 3 1.3432 3 3zM8.5 7c.8284 0 1.5-.6716 1.5-1.5S9.3284 4 8.5 4 7 4.6716 7 5.5 7.6716 7 8.5 7M10 9.5c0 .8284-.6716 1.5-1.5 1.5S7 10.3284 7 9.5 7.6716 8 8.5 8s1.5.6716 1.5 1.5"
    clipRule="evenodd"
  />,
  'PhoneCamera',
  24
);

export const PhoneRemoveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M14 1c1.6569 0 3 1.3432 3 3v5c-4.4183 0-8 3.5817-8 8 0 2.3901 1.0493 4.5341 2.7109 6H4c-1.6568 0-3-1.3431-3-3V4c0-1.6568 1.3432-3 3-3zM7.5606 4C6.975 4 6.5 4.475 6.5 5.0606c.0001.5854.475 1.0605 1.0606 1.0605h2.8789c.5855 0 1.0604-.475 1.0605-1.0606S11.0251 4 10.4395 4z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M17 11c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6m-3 5v2h6v-2z"
      key="1"
    />,
  ],
  'PhoneRemove',
  24
);

export const PhoneIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M17 1c1.6569 0 3 1.3432 3 3v16c0 1.6569-1.3431 3-3 3H7c-1.6569 0-3-1.3431-3-3V4c0-1.6568 1.3431-3 3-3zm-5 16.5c-.6904 0-1.25.5596-1.25 1.25S11.3096 20 12 20s1.25-.5596 1.25-1.25-.5596-1.25-1.25-1.25M10.5605 4C9.975 4 9.5 4.475 9.5 5.0606c.0001.5854.475 1.0605 1.0605 1.0605h2.879c.5855 0 1.0604-.475 1.0605-1.0606S14.0251 4 13.4395 4z"
  />,
  'Phone',
  24
);

export const PinIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M11.8184 0a9.82 9.82 0 0 1 6.9423 2.876 9.82 9.82 0 0 1 2.876 6.9424C21.6366 17.439 11.8583 23.9733 11.8184 24c0 0-9.8183-6.5454-9.8184-14.1816A9.818 9.818 0 0 1 4.876 2.876 9.818 9.818 0 0 1 11.8184 0M12 7c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3-1.3431-3-3-3"
  />,
  'Pin',
  24
);

export const PointsIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M9 4c0-1.6568 1.3431-3 3-3s3 1.3432 3 3-1.3431 3-3 3-3-1.3431-3-3m0 16c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3m11.4282-6.5981c1.4349.8284 1.9265 2.6632 1.0981 4.0981s-2.6632 1.9265-4.0981 1.0981-1.9265-2.6632-1.098-4.0981 2.6632-1.9265 4.098-1.0981M12 9c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3 1.3431-3 3-3M6.5718 5.402c1.4349.8284 1.9265 2.6631 1.098 4.098s-2.6631 1.9265-4.098 1.0981-1.9265-2.6632-1.098-4.098c.8283-1.435 2.6631-1.9266 4.098-1.0982m10.8564.0001c1.4349-.8285 3.2697-.3369 4.0981 1.098s.3368 3.2697-1.0981 4.0981-3.2696.3368-4.0981-1.098c-.8284-1.435-.3368-3.2697 1.0981-4.0982m-13.8564 8c1.4349-.8284 3.2696-.3368 4.098 1.0981.8285 1.4349.3369 3.2697-1.098 4.0981s-3.2697.3368-4.098-1.0981c-.8285-1.4349-.3369-3.2696 1.098-4.0981"
    clipRule="evenodd"
  />,
  'Points',
  24
);

export const PosterIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m16.0683 10.5205 3.6402 5.6626L19 22.5959H5.7071l-1.4142-1.4142 4.1745-5.1746 3.2568 2.0535z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 1c1.6569 0 3 1.3432 3 3v16c0 1.6569-1.3431 3-3 3H7c-1.6569 0-3-1.3431-3-3V4c0-1.6569 1.3431-3 3-3zm1 3c0-.5523-.4477-1-1-1H7c-.5523 0-1 .4477-1 1v16c0 .5523.4477 1 1 1h10c.5523 0 1-.4477 1-1z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M10.5 10c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2"
      key="2"
    />,
  ],
  'Poster',
  24
);

export const PrinterIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 1v4h12V1z"
      clipRule="evenodd"
      key="0"
    />,
    <path fill="currentColor" d="M18 14H6v8h12z" key="1" />,
    <path
      fill="currentColor"
      d="M4 7c-1.6568 0-3 1.3431-3 3v9h3v-5c0-1.1046.8954-2 2-2h12a2 2 0 0 1 2 2v5h3v-9c0-1.6569-1.3431-3-3-3z"
      key="2"
    />,
  ],
  'Printer',
  24
);

export const ProductsIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M22 22c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V7h20zm-6-12c-.5523 0-1 .4477-1 1 0 1.6877-1.3123 3-3 3s-3-1.3123-3-3c0-.5523-.4477-1-1-1s-1 .4477-1 1c0 2.7923 2.2077 5 5 5s5-2.2077 5-5c0-.5523-.4477-1-1-1m5.4-5-3.7-3.7c-.2-.2-.4-.3-.7-.3H7c-.3 0-.5.1-.7.3L2.6 5z"
  />,
  'Products',
  24
);

export const ProfileIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="m23.447 19.658-1.09-2.18c-.435-.869-1.267-1.477-2.228-1.624l-4.566-.703c-1.075.538-2.282.848-3.564.848s-2.489-.31-3.564-.848l-4.566.703c-.961.147-1.793.755-2.228 1.624l-1.09 2.18c-.469.937-.419 2.028.131 2.919C1.233 23.468 2.187 24 3.235 24h17.529c1.048 0 2.002-.532 2.553-1.423.55-.891.599-1.982.13-2.919M12 0C8.691 0 6 2.691 6 6v2c0 3.309 2.691 6 6 6s6-2.691 6-6V6c0-3.309-2.691-6-6-6" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Profile',
  24
);

export const ProtectedIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M21 3c-2.89 0-5.622-.609-8.598-1.916L12 .907l-.402.177C8.622 2.391 5.89 3 3 3H2v8c0 9.69 9.685 11.955 9.783 11.976l.217.048.217-.048C12.315 22.955 22 20.69 22 11V3zM10.28 16.444 6.586 12.75 8 11.336l2.22 2.22 5.721-6.219 1.472 1.354z"
  />,
  'Protected',
  24
);

export const QuestionIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1m0 17.5c-.689 0-1.25-.561-1.25-1.25S11.311 16 12 16s1.25.561 1.25 1.25-.561 1.25-1.25 1.25m2.19-6.482c-.702.518-1.087.829-1.2 1.515l.005.968h-2.133l.13-1.124c.205-1.639 1.25-2.407 2.014-2.969.774-.57 1.148-.881 1.177-1.715.044-1.317-.948-1.646-1.788-1.688-1.092-.059-1.901.549-2.184 1.619l-.253.967-1.935-.507.254-.968c.522-1.995 2.18-3.218 4.22-3.109 2.311.119 3.757 1.593 3.684 3.755-.062 1.839-1.176 2.659-1.99 3.257z"
  />,
  'Question',
  24
);

export const RadiusIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M11 21v-6.5c0-.5523.4477-1 1-1s1 .4477 1 1V21c0 .5523-.4477 1-1 1s-1-.4477-1-1m10-10c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6.5c-.5523 0-1-.4477-1-1s.4477-1 1-1z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12.5 15.5c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M2 21v-9C2 6.4772 6.4772 2 12 2h9c.5523 0 1 .4477 1 1s-.4477 1-1 1h-9c-4.4183 0-8 3.5817-8 8v9c0 .5523-.4477 1-1 1s-1-.4477-1-1"
      key="2"
    />,
  ],
  'Radius',
  24
);

export const ReceiptIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M21 4c0-1.6568-1.3431-3-3-3H6C4.3431 1 3 2.3432 3 4v19.118l4.9456-2.4728L12 23.1792l4.0544-2.534L21 23.118zM7 6h5v2H7zm0 4v2h5v-2zm0 4h5v2H7zm7-8v2h3V6zm0 4h3v2h-3zm0 4v2h3v-2z"
    clipRule="evenodd"
  />,
  'Receipt',
  24
);

export const RefundIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M1 4c0-1.6568 1.3432-3 3-3h16c1.6569 0 3 1.3432 3 3v1H1zm22 6h-4v.3145A7.49 7.49 0 0 0 16.8535 10c-2.2215.0001-4.2202.97-5.5889 2.499l-2.001 2.2354.8555.7656H9V19H4c-1.6568 0-3-1.3431-3-3V8h22zM4 15h4v-2H4z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M16.5 19.5h-2.2266c.6324.9067 1.6839 1.5 2.8731 1.5 1.036-.0001 1.9661-.4495 2.6084-1.167l.667-.7451 1.4902 1.334-.667.7451c-1.0056 1.1234-2.4699 1.8329-4.0986 1.833-1.6554 0-3.1387-.7314-4.1465-1.8877V23h-2v-5.5h5.5zm6.5-2h-5.5v-2h2.2266c-.6324-.9067-1.6839-1.5-2.8731-1.5-1.036.0001-1.9661.4495-2.6084 1.167l-.667.7451-1.4902-1.334.667-.7451c1.0056-1.1234 2.4699-1.8329 4.0986-1.833 1.6551 0 3.1387.7307 4.1465 1.8867V12h2z"
      key="1"
    />,
  ],
  'Refund',
  24
);

export const RemoveCircleIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 1c6.0751 0 11 4.9249 11 11s-4.9249 11-11 11S1 18.0751 1 12 5.9249 1 12 1M8 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
  />,
  'RemoveCircle',
  24
);

export const RemoveIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M5.0002 12c0-.5523.4476-.9999.9998-.9999h11.3138c.5522 0 .9998.4476.9998.9999s-.4476.9999-.9998.9999H6c-.5522 0-.9999-.4476-.9999-.9999"
  />,
  'Remove',
  24
);

export const RenameIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M22 23H2c-.553 0-1-.448-1-1s.447-1 1-1h20c.553 0 1 .448 1 1s-.447 1-1 1M18.414 8l2-2c.378-.378.586-.88.586-1.414s-.208-1.037-.586-1.414l-1.586-1.586c-.779-.78-2.049-.78-2.828 0l-2 2zm-5.828-3-7.293 7.293c-.096.096-.171.21-.222.335l-2 5a1 1 0 0 0 .222 1.079 1 1 0 0 0 1.078.222l5-2c.126-.05.24-.126.336-.222L17 9.414z"
  />,
  'Rename',
  24
);

export const ReportingIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 1c6.0751 0 11 4.9249 11 11s-4.9249 11-11 11S1 18.0751 1 12 5.9249 1 12 1M7 11v4h2v-4zm4-4v8h2V7zm4 2v6h2V9z"
  />,
  'Reporting',
  24
);

export const RomanceIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="m17.7931 4.793 4.5-4.5 1.4141 1.414-4.5 4.5zM12.4141 13l-7.707 7.707-1.4141-1.414L11 11.5859z" />
      <path d="M16.3467 4C19.4673 4 22 6.5496 22 9.6943 22 15.0732 13.8289 20.9412 11.5 22c-.6846-.3113-1.8735-1.039-3.212-2.0469l5.5401-5.539c.7811-.7811.7811-2.0471 0-2.8282l-1.414-1.414c-.7323-.7323-1.8912-.7785-2.6768-.1377l-.1514.1377-5.703 5.7021C2.237 13.9468 1 11.7848 1 9.6943 1 6.5496 3.5306 4 6.6533 4c2.058 0 3.5972 1.2986 4.8467 2.7598C12.7516 5.3008 14.2887 4 16.3467 4M3 21H0v-2h5v5H3zM21.1836 3.4482l-.4746-.1572-.1572-.4746L19.6123 0H24v4.3877z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Romance',
  24
);

export const RotateClockwiseIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 20.5c-4.6944 0-8.5-3.8056-8.5-8.5S7.3056 3.5 12 3.5c3.1654 0 5.9281 1.7299 7.3919 4.3003l.1019.184 1.7552-.9587a10 10 0 0 0-.1127-.2037l-.4817-.8701-.0509.0281C18.7059 3.2725 15.5605 1.5 12 1.5 6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12v-1h-2v1c0 4.6944-3.8056 8.5-8.5 8.5"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.5 1.5v5h-5v2h7v-7z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'RotateClockwise',
  24
);

export const RulerIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M3 6c0 1.1046.8954 2 2 2h7V6h2v2h10v12h-5v-4h-2v4h-3v-4h-2v4H9v-4H7v4H6c-2.7614 0-5-2.2386-5-5V6z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12 6c0-.291-.2301-.7742-1.0898-1.2432C10.0882 4.3085 8.8844 4 7.5 4s-2.5882.3085-3.4102.7568C3.2301 5.2258 3 5.7091 3 6s.2301.7742 1.0898 1.2432C4.9118 7.6915 6.1156 8 7.5 8s2.5882-.3085 3.4102-.7568C11.7699 6.7742 12 6.2909 12 6m2 0c0 1.3658-1.0011 2.3822-2.1318 2.999C10.6995 9.6365 9.1532 10 7.5 10s-3.1995-.3635-4.3682-1.001C2.0011 8.3822 1 7.3658 1 6s1.0011-2.3822 2.1318-2.999C4.3005 2.3635 5.8468 2 7.5 2s3.1995.3635 4.3682 1.001C12.9989 3.6178 14 4.6342 14 6"
      key="1"
    />,
  ],
  'Ruler',
  24
);

export const SantaIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M22 17.3824V10.5C22 4.7105 17.2896 0 11.5 0 6.2304 0 1.8398 3.8831 1.1102 9H1c-.5522 0-1 .4477-1 1v4c0 .5522.4478 1 1 1h15v2.3824c-.6146.7035-1 1.6124-1 2.6176 0 2.2056 1.7944 4 4 4s4-1.7944 4-4c0-1.0052-.3854-1.9141-1-2.6176M2 11h14v2H2zm17 11c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
  />,
  'Santa',
  24
);

export const ScrollVerticalIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M2.9998 10.0002V2.9996h1.9998v.0014l.0006 6.9986zm0 3.9996v7.0006l2.0004-.0007v-6.9992z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M3.9999 1.586 7.9139 5.5 6.5 6.914 4 4.414l-2.5 2.5L.0859 5.5zM4 22.414 7.914 18.5 6.5 17.0859l-2.5 2.5-2.5-2.5L.086 18.5zM14.5 9V2.9999c0-.8284-.6716-1.5-1.5-1.5s-1.5.6716-1.5 1.5V13.5h-1v-5C9.1193 8.5 8 9.6193 8 11v2.7484a2 2 0 0 0 .4948 1.317l1.763 2.5863A3 3 0 0 1 11 19.6272v2.8727h10.55l1.4733-8.6884c.2671-1.5753-.7473-3.0835-2.307-3.4301z"
      key="1"
    />,
  ],
  'ScrollVertical',
  24
);

export const SearchIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m21 21-5.344-5.344"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M10 18c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8"
      key="1"
    />,
  ],
  'Search',
  24
);

export const SeatLockIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M7 17v2a1 1 0 1 0 2 0v-2zm10.5-6c1.9333 0 3.5 1.5667 3.5 3.5V16c1.1046 0 2 .8954 2 2v3c0 1.1046-.8954 2-2 2h-7c-1.1046 0-2-.8954-2-2v-3c0-1.1046.8954-2 2-2v-1.5c0-1.9333 1.5667-3.5 3.5-3.5m0 2c-.8287 0-1.5.6713-1.5 1.5V16h3v-1.5c0-.8287-.6713-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12.6016 12A5.474 5.474 0 0 0 12 14.5v.0361A4.02 4.02 0 0 0 10.5371 16H5v5a1 1 0 0 1-.293.707.9997.9997 0 0 1-1.414 0A1 1 0 0 1 3 21v-7a2 2 0 0 1 2-2zM16 2c.7956 0 1.5585.3163 2.1211.879A3 3 0 0 1 19 5v4.208A5.5 5.5 0 0 0 17.5 9a5.473 5.473 0 0 0-3.1602 1H5V5c0-.7957.3163-1.5585.879-2.121A3 3 0 0 1 8 2z"
      key="1"
    />,
  ],
  'SeatLock',
  24
);

export const SeatIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M7 17v2a1 1 0 1 0 2 0v-2zm8 0v2a1.0001 1.0001 0 0 0 2 0v-2z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M19 12H5a2 2 0 0 0-2 2v7a1 1 0 1 0 2 0v-5h14v5a1.0001 1.0001 0 0 0 2 0v-7a2 2 0 0 0-2-2m0-2V5a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v5z"
      key="1"
    />,
  ],
  'Seat',
  24
);

export const SectionsIcon = createSvgIcon(
  [
    <path fill="currentColor" d="M2 11h20V2H2zm0 7h20v-5H2z" key="0" />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 22H2v-2h20z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Sections',
  24
);

export const SelectAreaIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 6V4.5C2 3.1193 3.1193 2 4.5 2H6v2H4.5a.5.5 0 0 0-.5.5V6zm18 0V4.5a.5.5 0 0 0-.5-.5H18V2h1.5C20.8807 2 22 3.1193 22 4.5V6zM4 19.5a.5.5 0 0 0 .5.5H6v2H4.5C3.1193 22 2 20.8807 2 19.5V18h2zM2 11V8h2v3zm0 5v-3h2v3zm18-5V8h2v3zM8 2h3v2H8zm5 0h3v2h-3zM8 20h3v2H8zm7.9507-2.6351 1.4142-1.4142L22.4143 21 21 22.4143z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m13.4189 21.3596 7.9406-7.9405L9.4131 9.413z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'SelectArea',
  24
);

export const SellTicketsIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M21.5 2c.828 0 1.5.672 1.5 1.5v5.5049c-1.65 0-3 1.3485-3 3 .0002 1.6498 1.3501 3 3 3V20.5c0 .828-.672 1.5-1.5 1.5h-19c-.828 0-1.5-.672-1.5-1.5v-5.4951c1.6499 0 2.9998-1.3502 3-3 0-1.65-1.35-3-3-3V3.5C1 2.672 1.672 2 2.5 2zm-4.793 6.293a.9996.9996 0 0 0-1.414 0l-4.626 4.6259-1.96-1.9589a.9997.9997 0 0 0-1.414 0c-.3904.3905-.3905 1.0236 0 1.414L9.96 15.04a.9997.9997 0 0 0 1.414 0l5.333-5.333a.9997.9997 0 0 0 0-1.414"
  />,
  'SellTickets',
  24
);

export const SettingsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="currentColor"
        d="M20.872 13.453A9 9 0 0 0 21 12a9 9 0 0 0-.128-1.453l2.1-2.029a1 1 0 0 0 .171-1.218l-1.5-2.6a1.009 1.009 0 0 0-1.143-.461l-2.8.8a9.02 9.02 0 0 0-2.527-1.451L14.47.758A1.0004 1.0004 0 0 0 13.5 0h-3a1 1 0 0 0-.97.758l-.707 2.83A9.02 9.02 0 0 0 6.3 5.039l-2.8-.8a1.01 1.01 0 0 0-1.143.461l-1.5 2.6a1 1 0 0 0 .171 1.219l2.1 2.029A9 9 0 0 0 3 12c.0034.487.0462.9729.128 1.453l-2.1 2.029A1 1 0 0 0 .857 16.7l1.5 2.6a1 1 0 0 0 .867.5 1.05 1.05 0 0 0 .275-.038l2.8-.8a9.02 9.02 0 0 0 2.527 1.451l.707 2.83A1 1 0 0 0 10.5 24h3a1 1 0 0 0 .6155-.212 1 1 0 0 0 .3545-.546l.707-2.83a9.02 9.02 0 0 0 2.523-1.451l2.8.8a1.05 1.05 0 0 0 .275.038 1 1 0 0 0 .867-.5l1.5-2.6a1 1 0 0 0-.171-1.219zM12 16a4.0002 4.0002 0 0 1-3.9231-4.7804A4 4 0 1 1 12 16"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Settings',
  24
);

export const ShareIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M1 20V10c0-.7957.3163-1.5585.879-2.121A3 3 0 0 1 4 7h3c.5523 0 1 .4477 1 1s-.4477 1-1 1H4a1 1 0 0 0-1 1v10c0 .2652.1054.5195.293.707A1 1 0 0 0 4 21h12a1 1 0 0 0 .707-.293A1 1 0 0 0 17 20v-5c0-.5523.4477-1 1-1s1 .4477 1 1v5a3 3 0 0 1-.8789 2.1211A3 3 0 0 1 16 23H4a3 3 0 0 1-2.121-.8789A3 3 0 0 1 1 20"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M8 16a11 11 0 0 1 3.2217-7.7783A11 11 0 0 1 19 5h3c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3a9 9 0 0 0-6.3643 2.6357A9 9 0 0 0 10 16c0 .5523-.4477 1-1 1s-1-.4477-1-1"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M17.293 1.293c.3905-.3905 1.0236-.3905 1.4141 0l4 4c.3905.3905.3905 1.0236 0 1.414l-4 4.0001c-.3905.3905-1.0236.3905-1.4141 0s-.3905-1.0236 0-1.414L20.586 6l-3.293-3.293c-.3905-.3906-.3905-1.0236 0-1.414"
      key="2"
    />,
  ],
  'Share',
  24
);

export const ShortcutsIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 0v1h4c1.6569 0 3 1.3432 3 3s-1.3431 3-3 3h-3.4444A.5555.5555 0 0 0 13 7.5556V11h-2V7.5556C11 6.1442 12.1442 5 13.5556 5H17c.5523 0 1-.4477 1-1s-.4477-1-1-1h-4c-1.1046 0-2-.8954-2-2V0z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 20v-8c0-1.6569-1.3431-3-3-3H4c-1.6568 0-3 1.3431-3 3v8c0 1.6568 1.3431 3 3 3h16c1.6569 0 3-1.3432 3-3M5 13v2h2.01v-2zm4 0h2.01v2H9zm0 4v2h6v-2zm-4 0h2.01v2H5zm12 0v2h2.01v-2zm-4-4h2.01v2H13zm4 0v2h2.01v-2z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Shortcuts',
  24
);

export const ShowIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M12 15c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5" />
      <path d="M12 20C4.496 20 .435 12.79.266 12.483L0 12l.266-.483C.435 11.21 4.496 4 12 4s11.565 7.21 11.735 7.517l.266.483-.266.483C23.565 12.79 19.504 20 12 20m-9.682-8c.993 1.505 4.401 6 9.682 6s8.689-4.495 9.683-6C20.69 10.495 17.28 6 12 6s-8.688 4.495-9.682 6" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Show',
  24
);

export const SoundIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M14.447 1.105c-.338-.167-.744-.132-1.047.095L5.667 7H1c-.553 0-1 .447-1 1v8c0 .553.447 1 1 1h4.667l7.733 5.8c.176.133.388.2.6.2.152 0 .306-.035.447-.105.339-.17.553-.516.553-.895V2c0-.379-.214-.725-.553-.895m3.7959 6.653-.707-.707-1.414 1.414.707.707c1.56 1.56 1.56 4.097 0 5.656l-.707.707 1.414 1.414.707-.707c2.339-2.339 2.339-6.145 0-8.484"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M20.364 4.222 18.95 5.636l.7069.707c3.119 3.119 3.119 8.195 0 11.314l-.7069.707 1.414 1.414.7069-.707c3.899-3.899 3.899-10.243 0-14.143z"
      key="1"
    />,
  ],
  'Sound',
  24
);

export const SparkleIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="m16.5 9.4614-2.1116 4.927L9.4614 16.5l4.927 2.1116 2.1116 4.927 2.1116-4.927 4.927-2.1116-4.927-2.1116zm-9-9-2.1116 4.927L.4614 7.5l4.927 2.1116L7.5 14.5386l2.1116-4.927L14.5386 7.5l-4.927-2.1116zM20.2 3.8 19 1l-1.2 2.8L15 5l2.8 1.2L19 9l1.2-2.8L23 5zm-14 14L5 15l-1.2 2.8L1 19l2.8 1.2L5 23l1.2-2.8L9 19z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sparkle',
  24
);

export const SpotifyAltIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="currentColor"
        d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.7 0 12 0m5.5 17.3c-.2.4-.7.5-1 .2-2.8-1.7-6.4-2.1-10.6-1.1-.4.1-.8-.2-.9-.5-.1-.4.2-.8.5-.9 4.6-1 8.5-.6 11.6 1.3.5.2.6.7.4 1M19 14c-.3.4-.8.6-1.3.3-3.2-2-8.2-2.6-11.9-1.4-.5.1-1-.1-1.1-.6s.1-1 .6-1.1c4.4-1.3 9.8-.7 13.5 1.6.3.2.5.8.2 1.2m.1-3.3C15.2 8.4 8.8 8.2 5.2 9.3c-.6.2-1.2-.2-1.4-.7-.2-.6.2-1.2.7-1.4 4.3-1.3 11.3-1 15.7 1.6.5.3.7 1 .4 1.6-.3.4-1 .6-1.5.3"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'SpotifyAlt',
  24
);

export const SpotifyIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M18.1857 17.7702c-.2354.4708-.8239.5885-1.177.2354-3.2953-2.0007-7.5322-2.4715-12.4753-1.2946-.4707.1177-.9415-.2354-1.0592-.5884-.1177-.4708.2354-.9416.5885-1.0593 5.4138-1.1769 10.0038-.7061 13.6522 1.53.5885.2354.7061.8239.4708 1.1769m1.7653-3.8838c-.353.4708-.9415.7062-1.53.3531-3.7661-2.3538-9.6507-3.06-14.0053-1.6477-.5884.1177-1.1769-.1177-1.2946-.7061-.1177-.5885.1177-1.177.7062-1.2947 5.1784-1.53 11.5338-.8238 15.8884 1.8831.353.2354.5884.9415.2353 1.4123m.1177-3.8838C15.4788 7.2956 7.9465 7.0603 3.7096 8.3549c-.7062.2354-1.4123-.2354-1.6477-.8238-.2354-.7062.2354-1.4123.8238-1.6477 5.0608-1.53 13.2992-1.177 18.4776 1.883.5885.3531.8239 1.177.4708 1.8831-.3531.4708-1.1769.7062-1.7654.3531"
  />,
  'Spotify',
  24
);

export const StadiumIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m2.8193 11.4844 9.1836 1.4619 8.4659-1.4619L23 8.0284l.9902.1415-1.5488 10.8135-.25.2393C20.1043 21.2212 16.4068 22 12.0029 22c-4.4036 0-8.107-.7786-10.1943-2.7773l-.25-.2393L.0098 8.1416 1 8zM9 16v3.8506c.9154.0978 1.9172.1494 3.0029.1494 1.0838 0 2.0836-.0519 2.9971-.1494V16z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12 6c2.0352 0 3.9252.352 5.3438.96.7073.3032 1.3443.6896 1.8183 1.1699.3037.3077.5588.6757.7051 1.0957-.253.1592-.5555.325-.917.4892C17.2744 10.4765 14.819 11 12 11s-5.2744-.5235-6.9502-1.2852c-.3618-.1644-.6648-.3298-.918-.4892.1463-.4202.4024-.7879.706-1.0957.4741-.4803 1.111-.8667 1.8185-1.17C8.0748 6.352 9.9648 6 12 6"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M22 8c0-.7474-.7123-1.7507-2.6357-2.625C17.5311 4.5417 14.9284 4 12 4s-5.531.5417-7.3643 1.375C2.7123 6.2493 2 7.2526 2 8s.7123 1.7507 2.6357 2.625C6.469 11.4583 9.0716 12 12 12s5.5311-.5417 7.3643-1.375C21.2877 9.7507 22 8.7474 22 8m2 0c0 2.0139-1.7499 3.5109-3.8076 4.4463C18.0444 13.4227 15.1467 14 12 14s-6.0444-.5773-8.1924-1.5537C1.75 11.5109 0 10.0139 0 8s1.75-3.511 3.8076-4.4463C5.9556 2.5773 8.8533 2 12 2s6.0444.5773 8.1924 1.5537C22.2501 4.4891 24 5.9861 24 8"
      key="2"
    />,
  ],
  'Stadium',
  24
);

export const StarIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="currentColor"
        d="M15.9708 8.75a1 1 0 0 1-.9487-.6838l-2.0734-6.2201c-.3039-.9117-1.5935-.9117-1.8974 0L8.9779 8.0662a1 1 0 0 1-.9487.6838H1.9668c-.9576 0-1.3676 1.2163-.6054 1.796l4.8909 3.7196a1 1 0 0 1 .3457 1.1049l-2.043 6.2887c-.2993.9213.7552 1.6874 1.539 1.118l5.3182-3.8642a1 1 0 0 1 1.1756 0l5.3183 3.8642c.7837.5694 1.8382-.1967 1.5389-1.118l-2.043-6.2887a1 1 0 0 1 .3457-1.1049l4.8909-3.7196c.7622-.5797.3522-1.796-.6054-1.796z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Star',
  24
);

export const StreamIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M12.0001 4.0006c1.0606 0 2.0781.421 2.8281 1.171l.7071.707-1.4141 1.415-.707-.707a2 2 0 0 0-1.4141-.586c-.5303 0-1.039.211-1.414.586l-.707.707-1.4141-1.415.707-.707a4 4 0 0 1 2.8281-1.171" />
      <path d="M12.0002-.0005a8.002 8.002 0 0 1 5.6573 2.3437l.707.707-1.4141 1.4142-.708-.707a6 6 0 0 0-4.2422-1.7578 6 6 0 0 0-4.2431 1.7578l-.707.707L5.636 3.0503l.707-.707A8 8 0 0 1 8.9387.6089a8 8 0 0 1 3.0615-.6094M9 10v7l7-3.5z" />
      <path d="M0 19V7c0-.7957.3163-1.5585.879-2.121A3 3 0 0 1 3 4h2v2H3a1 1 0 0 0-1 1v12c0 .2652.1054.5195.293.707A1 1 0 0 0 3 20h18a1 1 0 0 0 .707-.293A1 1 0 0 0 22 19V7a1 1 0 0 0-.293-.707 1 1 0 0 0-.6084-.2881L21 6h-2V4h2c.7957 0 1.5585.3163 2.1211.879A3 3 0 0 1 24 7v12a3 3 0 0 1-.8789 2.1211A3 3 0 0 1 21 22H3a3 3 0 0 1-2.121-.8789A3 3 0 0 1 0 19" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Stream',
  24
);

export const SwapUserIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M6 6c1.6569 0 3-1.3431 3-3S7.6569 0 6 0 3 1.3432 3 3s1.3431 3 3 3m11.9139.5-1.5-1.5h2.586c.551 0 1 .449 1 1v2h2V6c0-1.654-1.346-3-3-3h-2.586l1.5-1.5-1.414-1.414L12.5859 4l3.914 3.914zM6.086 17.5l1.5 1.5H5c-.551 0-1-.449-1-1v-2H2v2c0 1.654 1.346 3 3 3h2.586l-1.5 1.5L7.5 23.914 11.414 20 7.5 16.086zm4.969-3.608.122-.86c.013-.093.023-.186.023-.282 0-2.895-2.355-5.25-5.25-5.25S.7 9.855.7 12.75c0 .095.01.188.026.308L.781 14h9.394zM18 16c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3m-.05 1.5c-2.895 0-5.25 2.355-5.25 5.25 0 .095.01.188.026.308l.055.942h9.394l.881-.108.122-.86c.013-.093.023-.186.023-.282 0-2.895-2.356-5.25-5.251-5.25" />
    </g>,
    <defs key="1"></defs>,
  ],
  'SwapUser',
  24
);

export const TagIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M22.121 11.207 11.914 1H1v10.914l10.207 10.207c.585.585 1.353.877 2.121.877s1.537-.292 2.122-.877l6.671-6.671c1.17-1.17 1.17-3.073 0-4.243M7.5 9C6.673 9 6 8.327 6 7.5S6.673 6 7.5 6 9 6.673 9 7.5 8.327 9 7.5 9"
  />,
  'Tag',
  24
);

export const TagsIcon = createSvgIcon(
  [
    <path fill="currentColor" d="M21 10.414 12.586 2H4V0h9.414l9 9z" key="0" />,
    <path
      fill="currentColor"
      d="M20.098 12.684 11.414 4H2v9.414l8.684 8.684c.585.585 1.353.877 2.122.877s1.536-.292 2.121-.877l5.171-5.171c1.17-1.169 1.17-3.073 0-4.243M7.5 11C6.673 11 6 10.327 6 9.5S6.673 8 7.5 8 9 8.673 9 9.5 8.327 11 7.5 11"
      key="1"
    />,
  ],
  'Tags',
  24
);

export const TextIcon = createSvgIcon(
  [
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd" key="0">
      <path d="M10.2245 16h-7.445v-2h7.445z" />
      <path d="M5.2128 4h2.5745l5.0794 16h-2.4574v-1.1311L6.5001 6.5549 2.5939 18.8592V20H.1334zm15.6897 10.0148c-1.1824.0345-2.4908.1384-3.3145.3772-1.2776.3704-1.6977 1.3845-1.564 2.1407.1558.8811 1.0143 1.4844 1.9867 1.467 1.5388-.0277 3.2178-.9091 4.0572-2.8401l1.8342.7973c-1.1695 2.6904-3.5793 4.0016-5.8555 4.0424-1.7087.0307-3.6252-1.0436-3.992-3.1184-.3149-1.781.7358-3.7601 2.9764-4.4098 1.0923-.3167 2.6291-.4209 3.8131-.4554a38 38 0 0 1 1.5478-.0131c.1488.0017.5728 2.0124.563 2.0121a27 27 0 0 0-.586-.0123 37 37 0 0 0-1.4664.0124" />
      <path d="M15.9682 8.3321A4.738 4.738 0 0 1 19.2619 7c2.6168 0 4.7382 2.1213 4.7382 4.7382V20h-2v-8.2618C22.0001 10.2259 20.7742 9 19.2619 9a2.738 2.738 0 0 0-1.9034.7698l-1.3821 1.3365-1.3903-1.4377z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Text',
  24
);

export const TheaterIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M15.334 1.278a21.767 21.767 0 0 0-14.668 0A1 1 0 0 0 0 2.221V12a8 8 0 0 0 8 8 8 8 0 0 0 8-8V2.221a1 1 0 0 0-.666-.943M3 8a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1m5 9a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3m4-8h-1a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2" />
      <path d="M23.334 5.273A22.07 22.07 0 0 0 18 4.1V12a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1.0003 1.0003 0 0 1-1-1 9.938 9.938 0 0 1-2.016 6H16a2.9997 2.9997 0 0 1 3 3h-6.724a9.86 9.86 0 0 1-1.877.7A7.9933 7.9933 0 0 0 24 16V6.215a1 1 0 0 0-.666-.942" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Theater',
  24
);

export const ThumbDownIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M8 14.9999v-12l7.6654-.7665c1.3716-.1372 2.6601.678 3.1237 1.976l3.2565 9.1178c.4652 1.3025-.5004 2.6727-1.8835 2.6727H14l.1803 5.0801c.0373 1.0491-.8032 1.9199-1.853 1.9199a1.854 1.854 0 0 1-1.7551-1.2565zM6 3.2l-3 .3V15h3z"
  />,
  'ThumbDown',
  24
);

export const ThumbUpIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="m8 9 2.5722-6.7435A1.854 1.854 0 0 1 12.3273 1c1.0498 0 1.8903.8708 1.853 1.9199L14 8h6.1621c1.3831 0 2.3487 1.3702 1.8835 2.6727l-3.2565 9.1178c-.4636 1.2981-1.7521 2.1132-3.1237 1.976L8 21zM6 9H3v11.5l3 .3z"
  />,
  'ThumbUp',
  24
);

export const TicketdownloadIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M22.5 2c.828 0 1.5.672 1.5 1.5V9c-1.65 0-3 1.3485-3 3 0 1.65 1.35 3 3 3v5.5c0 .828-.672 1.5-1.5 1.5h-21C.672 22 0 21.328 0 20.5V15c1.65 0 3-1.35 3-3S1.65 9 0 9V3.5C0 2.672.672 2 1.5 2zM10.9141 13.5859l-2.5-2.5L7 12.5l4.9141 4.9141 4.914-4.9141-1.414-1.4141-2.5 2.5V7h-2z"
  />,
  'Ticketdownload',
  24
);

export const TicketIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M22.5 2c.828 0 1.5.672 1.5 1.5v5.5049c-1.65 0-3 1.3485-3 3 .0002 1.6498 1.3501 3 3 3V20.5c0 .828-.672 1.5-1.5 1.5h-21C.672 22 0 21.328 0 20.5v-5.4951c1.6499 0 2.9998-1.3502 3-3 0-1.65-1.35-3-3-3V3.5C0 2.672.672 2 1.5 2zm-6.375 13.875c-.6213 0-1.125.5037-1.125 1.125s.5037 1.125 1.125 1.125S17.25 17.6213 17.25 17s-.5037-1.125-1.125-1.125m0-5c-.6213 0-1.125.5037-1.125 1.125s.5037 1.125 1.125 1.125S17.25 12.6213 17.25 12s-.5037-1.125-1.125-1.125m0-5C15.5037 5.875 15 6.3787 15 7s.5037 1.125 1.125 1.125S17.25 7.6213 17.25 7s-.5037-1.125-1.125-1.125"
  />,
  'Ticket',
  24
);

export const TilesIrregularIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M9 2H2v7h7zm0 13H2v7h7zM22 2h-7v7h7zm0 13h-7v7h7z"
      key="0"
    />,
    <path fill="currentColor" d="M15.5 8.5h-7v7h7z" key="1" />,
    <path fill="currentColor" d="M22 8.5h-7v7h7z" key="2" />,
    <path fill="currentColor" d="M15.5 15h-7v7h7z" key="3" />,
  ],
  'TilesIrregular',
  24
);

export const TransferIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M11 10c2.4853 0 4.5-2.0147 4.5-4.5S13.4853 1 11 1 6.5 3.0147 6.5 5.5 8.5147 10 11 10m5 11h-3c-1.104 0-2-.896-2-2v-2c0-1.104.896-2 2-2h3v-1.478C14.569 12.562 12.849 12 11 12c-4.963 0-9 4.038-9 9v.781l.758.189c2.734.684 5.488 1.025 8.242 1.025 1.668 0 3.336-.141 5-.392z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M13 17.207v2h6.5858l-2.5 2.5L18.5 23.1212l4.9142-4.9142L18.5 13.2928l-1.4142 1.4142 2.5 2.5z"
      key="1"
    />,
  ],
  'Transfer',
  24
);

export const TrashIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m4.166 8 .505 12.125A2.993 2.993 0 0 0 7.669 23h8.663c1.613 0 2.93-1.263 2.998-2.875L19.835 8zM10.5 19h-2v-8h2zm5 0h-2v-8h2z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M19 3h-4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2H5C3.346 3 2 4.346 2 6v3h20V6c0-1.654-1.346-3-3-3m1 4H4V6c0-.552.449-1 1-1h14c.551 0 1 .448 1 1z"
      key="1"
    />,
  ],
  'Trash',
  24
);

export const TreeIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path
        fillRule="evenodd"
        d="m12 .6515 5.3842 11.4412-1.6596.5532L17.8258 20H6.1743l2.1012-7.3541-1.6596-.5532z"
        clipRule="evenodd"
      />
      <path d="M19.3343 18h4.5933l-2.1368-5.8762 1.6192-.5397L18.0797.9235 15.9829 4.418l4.1695 8.8601-1.9787.6595zM8.0171 4.4181 5.9203.9235.59 11.584l1.6192.5397L.0724 18h4.5933l1.1607-4.0623-1.9787-.6595z" />
      <path fillRule="evenodd" d="M13 18v6h-2v-6z" clipRule="evenodd" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tree',
  24
);

export const UndoIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M18.75 14.1875c0 1.0913-.3795 2.0265-1.0557 2.6885C17.0206 17.5355 15.9735 18 14.5 18h-4.375c-.5523 0-1 .4477-1 1s.4477 1 1 1H14.5c1.9092 0 3.4872-.613 4.5928-1.6953 1.103-1.0798 1.6572-2.5507 1.6572-4.1172s-.5542-3.0374-1.6572-4.1172C17.9872 8.988 16.4092 8.375 14.5 8.375H4c-.5523 0-1 .4477-1 1s.4477 1 1 1h10.5c1.4735 0 2.5206.4645 3.1943 1.124.6762.662 1.0557 1.5972 1.0557 2.6885"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M7.668 14.457c.3905.3905 1.0235.3905 1.414 0 .3906-.3905.3906-1.0236 0-1.4141l-3.6679-3.668 3.668-3.668c.3905-.3904.3905-1.0235 0-1.414s-1.0236-.3905-1.414 0L3.293 8.668c-.3906.3906-.3906 1.0236 0 1.4141z"
      key="1"
    />,
  ],
  'Undo',
  24
);

export const UnlockedIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M20 8H4c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h16c1.105 0 2-.895 2-2V10c0-1.105-.895-2-2-2m-8 10c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M16.798 2.363C15.677.881 13.968.02 12.11 0h-.161C8.697 0 6.034 2.63 6 5.9V9h2V5.911C8.022 3.746 9.79 2 12.047 2h.042c1.234.013 2.369.585 3.113 1.57.334.439.959.528 1.401.194.44-.333.528-.96.195-1.401"
      key="1"
    />,
  ],
  'Unlocked',
  24
);

export const UploadIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M1 19v-4c0-.5523.4477-1 1-1s1 .4477 1 1v4l.0049.0986a1 1 0 0 0 .288.6084A1 1 0 0 0 4 20h16a1 1 0 0 0 .707-.293A1 1 0 0 0 21 19v-4c0-.5523.4477-1 1-1s1 .4477 1 1v4a3 3 0 0 1-.8789 2.1211A3 3 0 0 1 20 22H4a3 3 0 0 1-2.121-.8789A3 3 0 0 1 1 19"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M11 16V3c0-.5523.4477-1 1-1s1 .4477 1 1v13c0 .5523-.4477 1-1 1s-1-.4477-1-1"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M17.7071 7.293c.3905.3905.3905 1.0235 0 1.414-.3905.3906-1.0236.3906-1.4141 0L12 4.414 7.707 8.707c-.3904.3906-1.0235.3906-1.414 0s-.3905-1.0235 0-1.414L12 1.586z"
      key="2"
    />,
  ],
  'Upload',
  24
);

export const UpsideDownIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M4 6v15c0 .2652.1054.5195.293.707A1 1 0 0 0 5 22h14a1 1 0 0 0 .707-.293A1 1 0 0 0 20 21V6c0-.5523.4477-1 1-1s1 .4477 1 1v15a3 3 0 0 1-.8789 2.1211A3 3 0 0 1 19 24H5a3 3 0 0 1-2.121-.8789A3 3 0 0 1 2 21V6c0-.7957.3163-1.5585.8789-2.121A3 3 0 0 1 5 3h1c.5523 0 1 .4477 1 1s-.4477 1-1 1H5a1 1 0 0 0-1 1" />
      <path d="M16.5791 0C19.5729 0 21.9999 2.427 22 5.4209v4.4209c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4209C19.9999 3.5316 18.4684 2.0001 16.5791 2c-1.8893 0-3.4208 1.5316-3.4209 3.4209v9.79c-.0002.552-.448.9999-1 1s-.9998-.4479-1-1v-9.79C11.1583 2.427 13.5852 0 16.5791 0" />
      <path d="M16.0228 12.293c.3905.3905.3905 1.0236 0 1.4141l-3.1582 3.1582c-.3906.3902-1.0237.3904-1.4141 0l-3.1572-3.1582c-.3905-.3905-.3905-1.0236 0-1.4141.3905-.3903 1.0236-.3904 1.414 0l2.4512 2.4502 2.4502-2.4502c.3905-.3905 1.0236-.3905 1.4141 0" />
    </g>,
    <defs key="1"></defs>,
  ],
  'UpsideDown',
  24
);

export const UrlIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M16.5 22.5c-1.603 0-3.109-.624-4.242-1.757l-3.122-3.122c-2.339-2.339-2.339-6.146 0-8.485.43-.429.918-.79 1.452-1.071l.886-.465.931 1.771-.885.465c-.356.187-.683.428-.97.714-1.559 1.56-1.559 4.097 0 5.657l3.122 3.122c1.512 1.511 4.145 1.511 5.656 0 .756-.756 1.172-1.76 1.172-2.829s-.416-2.073-1.172-2.829L17.6 11.942l1.414-1.414 1.728 1.728c1.134 1.133 1.758 2.64 1.758 4.243s-.624 3.109-1.758 4.243c-1.133 1.133-2.64 1.758-4.242 1.758"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m12.511 16.405-.926-1.772.887-.463c.358-.188.688-.43.979-.72 1.559-1.559 1.559-4.097 0-5.656l-3.122-3.122c-1.512-1.511-4.145-1.511-5.656 0-.756.756-1.172 1.76-1.172 2.829s.416 2.073 1.172 2.829l1.728 1.729-1.414 1.414-1.728-1.728c-1.134-1.133-1.758-2.64-1.758-4.243s.624-3.109 1.758-4.243c1.133-1.133 2.64-1.757 4.242-1.757s3.109.624 4.242 1.757l3.122 3.122c2.339 2.339 2.339 6.146 0 8.485-.435.435-.929.797-1.467 1.078l-.887.463z"
      key="1"
    />,
  ],
  'Url',
  24
);

export const UserAltIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="m17.24 12.561.609-3.656C18.451 5.291 15.664 2 12 2S5.548 5.29 6.151 8.905l.609 3.656C7.187 15.122 9.403 17 12 17s4.813-1.877 5.24-4.439m-9.241 5.247A2.002 2.002 0 0 1 6.55 19.66l-4.099 1.171A1.9996 1.9996 0 0 0 1 22.754V23h22v-.246c0-.893-.592-1.678-1.451-1.923L17.45 19.66a1.999 1.999 0 0 1-1.449-1.852A7.29 7.29 0 0 1 12 19c-1.466 0-2.845-.435-4.001-1.192"
  />,
  'UserAlt',
  24
);

export const UserEditIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M11 10c2.4853 0 4.5-2.0147 4.5-4.5S13.4853 1 11 1 6.5 3.0147 6.5 5.5 8.5147 10 11 10m4 13 6.5-6.5c.8284-.8284.8284-2.1716 0-3s-2.1716-.8284-3 0L12 20v3zm.785-9.6134C14.3981 12.5111 12.7585 12 11.001 12c-4.962 0-9 4.038-9 9v.781l.757.189c2.4034.6004 4.8217.9318 7.242 1.0039V20a2 2 0 0 1 .5858-1.4142z"
  />,
  'UserEdit',
  24
);

export const UserInformationIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M23 5h-7v2h7zm0 4h-7v2h7zm0 4h-4v2h4zM9.5 10c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4m0 2c-4.411 0-8 3.589-8 8v.754l.725.207c2.414.69 4.844 1.035 7.275 1.035s4.861-.345 7.275-1.035l.725-.207V20c0-4.411-3.589-8-8-8"
  />,
  'UserInformation',
  24
);

export const UserTicketIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M9.5 12c.376 0 .746.0277 1.1084.0781A1.002 1.002 0 0 0 10 13v8.9902a25 25 0 0 1-.5.0059c-2.431 0-4.8614-.3452-7.2754-1.0352l-.7246-.207V20c0-4.411 3.589-8 8-8M23 14a1 1 0 0 1 .707.293A1 1 0 0 1 24 15v2a2.0003 2.0003 0 0 0-2 2 2.0003 2.0003 0 0 0 2 2v2a1 1 0 0 1-.293.707A1 1 0 0 1 23 24H13a1 1 0 0 1-.707-.293A1 1 0 0 1 12 23v-2a2.0003 2.0003 0 0 0 2-2 2.0003 2.0003 0 0 0-2-2v-2a1 1 0 0 1 .293-.707A1 1 0 0 1 13 14zm-3.25 7.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M9.5 10c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4"
  />,
  'UserTicket',
  24
);

export const UserIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1M9.289 7.209A3.648 3.648 0 0 1 12 6c1.032 0 2.021.44 2.711 1.209.69.768 1.023 1.797.913 2.824l-.084.786C15.346 12.632 13.823 14 12 14s-3.346-1.368-3.54-3.181l-.084-.786c-.11-1.027.223-2.056.913-2.824M12 21c-2.591 0-4.922-1.107-6.566-2.864.202-.592.657-1.062 1.251-1.259 3.525-1.165 7.103-1.166 10.628 0 .595.197 1.049.667 1.252 1.26C16.921 19.894 14.59 21 12 21"
  />,
  'User',
  24
);

export const UsersIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M16.5 8C18.433 8 20 6.433 20 4.5S18.433 1 16.5 1 13 2.567 13 4.5 14.567 8 16.5 8m-9 5.5c1.933 0 3.5-1.567 3.5-3.5S9.433 6.5 7.5 6.5 4 8.067 4 10s1.567 3.5 3.5 3.5m9-4c-1.301 0-2.511.388-3.528 1.049-.132 1.318-.731 2.5-1.629 3.379 1.548.789 2.808 2.046 3.631 3.572h7.914l.083-.909c.018-.195.03-.392.03-.591 0-3.584-2.917-6.5-6.501-6.5m-9 5.5C3.916 15 1 17.916 1 21.5c0 .2.012.396.03.591l.083.909h12.774l.083-.909c.018-.195.03-.392.03-.591 0-3.584-2.916-6.5-6.5-6.5"
  />,
  'Users',
  24
);

export const WaitlistIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M11 10c2.4853 0 4.5-2.0147 4.5-4.5S13.4853 1 11 1 6.5 3.0147 6.5 5.5 8.5147 10 11 10m-1 8c0-2.312.992-4.392 2.566-5.854-.51-.09-1.031-.146-1.566-.146-4.962 0-9 4.038-9 9v.781l.757.189c2.735.684 5.489 1.025 8.243 1.025.248 0 .496-.018.744-.023C10.655 21.605 10 19.88 10 18"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M18 12c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6m2 9.414-3-3V14.5h2v3.086L21.414 20z"
      key="1"
    />,
  ],
  'Waitlist',
  24
);

export const WalletAltIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M8.538 12c.6914 1.1942 1.9808 2 3.462 2s2.7706-.8058 3.4619-2H21c1.1046 0 2 .8954 2 2v6c0 1.1046-.8954 2-2 2H3a2 2 0 0 1-.2041-.0107c-.9416-.0955-1.6897-.8436-1.7852-1.7852A2 2 0 0 1 1 20v-6c0-1.1046.8954-2 2-2zM21 7c1.1046 0 2 .8954 2 2v1.5361A3.98 3.98 0 0 0 21 10h-6.8779l-.2354.667C13.6116 11.4451 12.8692 12 12 12s-1.6116-.5549-1.8867-1.333L9.8779 10H3a3.98 3.98 0 0 0-2 .5361V9c0-1.1046.8954-2 2-2zm0-5c1.1046 0 2 .8954 2 2v1.5361A3.98 3.98 0 0 0 21 5H3a3.98 3.98 0 0 0-2 .5361V4c0-1.1046.8954-2 2-2z"
  />,
  'WalletAlt',
  24
);

export const WalletIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M22 5H4c-.551 0-1-.449-1-1s.449-1 1-1h13v1h2V2c0-.552-.448-1-1-1H4C2.343 1 1 2.343 1 4v15c0 2.209 1.791 4 4 4h17c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1m-5 11c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2"
  />,
  'Wallet',
  24
);

export const WheelchairIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M11 6c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3432-3 3 1.3431 3 3 3m9 17c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2m-1.821-8.77A1.999 1.999 0 0 0 16.333 13h-2.486l-.722-4.329C12.964 7.707 12.13 7 11.152 7H8.667c-.649 0-1.281.211-1.8.6l-2.76 2.07c-.807.605-1.037 1.717-.537 2.593l2.058 3.602 1.736-.992-2.058-3.602L8 9.251v2.75l3.729.746.032.21c.225 1.463 1.484 2.544 2.965 2.544h1.607l1.194 2.884 2.03-.846-1.378-3.308z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M9 11c-.125 0-.244.014-.453.041L8 11.083v2.006l.701-.054c.07-.005.139-.014.299-.035 2.206 0 4 1.794 4 4s-1.794 4-4 4c-2.06 0-3.8-1.62-3.963-3.687l-.079-.997-1.994.157.079.997C3.288 20.571 5.904 23 9.001 23c3.309 0 6-2.691 6-6s-2.691-6-6-6z"
      key="1"
    />,
  ],
  'Wheelchair',
  24
);

export const WidgetSimpleIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M21 2c1.1046 0 2 .8954 2 2v16c0 1.1046-.8954 2-2 2H3c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2zM7.9404 7l-.2666.2002-2.2734 1.705-.8008.5997 1.2002 1.6006.7998-.6006 1.2422-.9317v7.3848h2V7zm6.2168 0c-1.8076.0003-3.2733 1.4657-3.2734 3.2734v1h2v-1c.0001-.703.5704-1.273 1.2734-1.2734h.4004C15.354 9.0002 16 9.646 16 10.4424c0 .576-.343 1.0973-.8721 1.3252l-2.5957 1.1172a2.728 2.728 0 0 0-1.6484 2.5048v1.5684H18v-2h-4.9717a.725.725 0 0 1 .2949-.2363l2.5957-1.1172A3.443 3.443 0 0 0 18 10.4424C18 8.5414 16.4586 7.0002 14.5576 7z"
  />,
  'WidgetSimple',
  24
);

export const WidgetIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M21 2c1.1046 0 2 .8954 2 2v16c0 1.1046-.8954 2-2 2H3c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2zm-1.1748 10.4346c-.3123-.4554-.9352-.5719-1.3906-.2598l-5.2676 3.6113-2.3516-1.6113-.123-.0713a1 1 0 0 0-.9385.0283l-5.25 3c-.4795.274-.646.8848-.372 1.3643s.8847.6461 1.3642.3721l4.706-2.6895 2.3995 1.6465a1.001 1.001 0 0 0 1.1308 0l5.833-4c.4554-.3123.5719-.9352.2598-1.3906M5 9c-.5523 0-1 .4477-1 1s.4477 1 1 1h10c.5523 0 1-.4477 1-1s-.4477-1-1-1zm0-4c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
  />,
  'Widget',
  24
);

export const WorldPinIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M23.155 9.7539a19.3 19.3 0 0 1-1.69 2.049c.017.231.035.462.035.7a9.425 9.425 0 0 1-.863 3.933l-.7-.677a.99.99 0 0 0-.5-.262l-3-.6a.99.99 0 0 0-.55.045l-3.1 1.175a1 1 0 0 0-.585.593l-.9 2.466-1.811 1.961a.98.98 0 0 0-.227.457 9.48 9.48 0 0 1-3.448-1.9l.13-.551 1.618-1.358a1 1 0 0 0 .319-1.041l-.674-2.36a.985.985 0 0 0-.23-.408l-1.172-1.253-.157-.267.579-.494 2.369-1.2a1 1 0 0 0 .537-.746l.387-2.616a1 1 0 0 0-.26-.83l-1.571-1.67a.9.9 0 0 0-.091-.093l-.515-.423a9.45 9.45 0 0 1 4.186-1.347 6.66 6.66 0 0 1 .941-2.026c-.074-.002-.142-.011-.212-.011a11.558 11.558 0 1 0 11.155 8.754" />
      <path d="M18.0001 0a4.945 4.945 0 0 0-4.6344 3.0778A4.94 4.94 0 0 0 13.0001 5c0 2.8 3.9 6.4 4.3 6.7a.967.967 0 0 0 .7.2999.967.967 0 0 0 .7-.2999c.4-.3 4.3-3.9 4.3-6.7a4.9453 4.9453 0 0 0-5-5m0 7a2 2 0 1 1 2-2 2.006 2.006 0 0 1-2 2" />
    </g>,
    <defs key="1"></defs>,
  ],
  'WorldPin',
  24
);

export const WorldIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m17.9072 20.0001-5.611 2.6699c-.486-.5386-.9484-1.3308-.8442-2.3436.1018-.9901.7212-1.9393 1.8088-2.8638.2-.1699.3355-.4353.3989-.9212.1744-1.3343-.184-2.7026.2852-4.0036.2902-.8048.873-1.4707 1.8625-1.8218 1.5056-.5342 3.0084-.1582 4.2259.8287.8241.668 1.4308 1.556 2.2423 2.2311z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.8619 4.724c1.456-1.4561 3.8253-1.4281 5.2465.062a3.916 3.916 0 0 1 1.0403 3.2738c-.1922 1.3034-.9951 2.2466-1.9662 2.8543-1.0865.6799-1.3787 2.0643-.7248 3.2868a4.577 4.577 0 0 1-.4428 4.9936c-.7593.9623-2.1884 1.0463-3.0551.1795L2.605 16.5 1.5 12l1.1051-5z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M19.5 5.5c-4.7751 3.985-8.0136.065-7.5-3.5l4.5 1z"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 3c-4.9706 0-9 4.0294-9 9s4.0294 9 9 9 9-4.0294 9-9-4.0294-9-9-9M1 12C1 5.9249 5.9249 1 12 1s11 4.9249 11 11-4.9249 11-11 11S1 18.0751 1 12"
      clipRule="evenodd"
      key="3"
    />,
  ],
  'World',
  24
);

export const XAltIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 0c6.6274 0 12 5.3726 12 12s-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0M5 6l5.293 6.9219-5.0166 5.7334h2.1484l3.8721-4.4239 3.3828 4.4239H19l-5.5166-7.294L18.1729 6h-2.1465l-3.5381 4.0439L9.4297 6zm3.7842 1.2178L16.4629 17.37h-1.1904L7.5068 7.2178z"
  />,
  'XAlt',
  24
);

export const XIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M17.7514 3h3.0667l-6.6997 7.6583L22 21.0786h-6.1717l-4.8336-6.3194-5.5315 6.3194H2.3948l7.166-8.1907L2 3h6.3279l4.3692 5.7769zm-1.0766 16.243h1.6998L7.405 4.7397H5.5812z"
  />,
  'X',
  24
);

export const YahooIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M10.827 13.5025 10.6707 22c.4964-.0877.9171-.1322 1.262-.1322.3282 0 .7488.0445 1.262.1322l-.1562-8.4975c.3209-.553.9952-1.7369 2.0252-3.5517 1.0301-1.815 1.8967-3.315 2.6022-4.5013A77 77 0 0 1 19.8414 2q-.6978.1803-1.2981.1803-.5173 0-1.3341-.1803a157 157 0 0 1-1.6046 2.7584c-.5649.9495-1.2344 2.0577-2.0073 3.3233a2634 2634 0 0 0-1.6646 2.7284c-.2969-.4892-.7356-1.1995-1.3161-2.1334S9.5649 6.982 9.2043 6.393c-.3605-.589-.7812-1.2945-1.262-2.1154S7.0325 2.697 6.6563 2c-.4327.1118-.8618.1683-1.2861.1683-.4483 0-.905-.0565-1.3702-.1683q.3371.4687.7212 1.0637c.256.3966.4543.7115.595.9435.1405.232.3665.6166.679 1.1538.3125.5373.5084.8739.589 1.0097 1.1694 1.9867 2.584 4.4315 4.2428 7.3318"
  />,
  'Yahoo',
  24
);

export const YoutubeIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M23.5118 6.6417a3.005 3.005 0 0 0-2.1129-2.1177C19.521 4.0084 12.0083 4 12.0083 4s-7.5115-.0084-9.3906.4845A3.07 3.07 0 0 0 .5 6.6165c-.4952 1.878-.5 5.7728-.5 5.7728s-.0048 3.914.4869 5.7727c.2758 1.0277 1.0852 1.8395 2.114 2.1165 1.8971.5156 9.3894.524 9.3894.524s7.5127.0084 9.3906-.4832a3.016 3.016 0 0 0 2.1189-2.1141c.4964-1.8767.5-5.7704.5-5.7704s.024-3.9152-.488-5.793M9.6052 15.9975l.006-7.1949 6.244 3.6035z"
  />,
  'Youtube',
  24
);
